(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-approach"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function gate(scope) {
      var root = scope && scope.querySelectorAll ? scope : document;
      var sections = root.querySelectorAll('.about-approach');

      Array.prototype.forEach.call(sections, function (el) {
        if (el.dataset.approachBound === '1') return;
        el.dataset.approachBound = '1';

        if (!('IntersectionObserver' in window)) {
          el.classList.add('is-in');
          return;
        }

        var io = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                el.classList.add('is-in');
                io.disconnect();
              }
            });
          },
          { threshold: 0.2 }
        );

        io.observe(el);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        gate(document);
      });
    } else {
      gate(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      gate(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["about-diff-rows"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function gate(scope) {
      var root = scope && scope.querySelectorAll ? scope : document;
      var sections = root.querySelectorAll('.about-diff-rows');

      Array.prototype.forEach.call(sections, function (el) {
        if (el.dataset.diffBound === '1') return;
        el.dataset.diffBound = '1';

        if (!('IntersectionObserver' in window)) {
          el.classList.add('is-in');
          return;
        }

        var io = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                el.classList.add('is-in');
                io.disconnect();
              }
            });
          },
          { threshold: 0.1 }
        );

        io.observe(el);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        gate(document);
      });
    } else {
      gate(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      gate(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["about-statement"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function gate(scope) {
      var root = scope && scope.querySelectorAll ? scope : document;
      var sections = root.querySelectorAll('.about-statement');

      Array.prototype.forEach.call(sections, function (el) {
        if (el.dataset.stmtBound === '1') return;
        el.dataset.stmtBound = '1';

        if (!('IntersectionObserver' in window)) {
          el.classList.add('is-in');
          return;
        }

        var io = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                el.classList.add('is-in');
                io.disconnect();
              }
            });
          },
          { threshold: 0.2 }
        );

        io.observe(el);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { gate(document); });
    } else {
      gate(document);
    }

    document.addEventListener('shopify:section:load', function (event) { gate(event.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["about-system"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function gate(scope) {
      var root = scope && scope.querySelectorAll ? scope : document;
      var panels = root.querySelectorAll('.sys-panel');

      Array.prototype.forEach.call(panels, function (panel) {
        if (panel.dataset.sysBound === '1') return;
        panel.dataset.sysBound = '1';

        if (!('IntersectionObserver' in window)) {
          panel.classList.add('play');
          return;
        }

        var io = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                panel.classList.add('play');
                io.disconnect();
              }
            });
          },
          { threshold: 0.25 }
        );

        io.observe(panel);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        gate(document);
      });
    } else {
      gate(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      gate(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["about-why"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function gate(scope) {
      var root = scope && scope.querySelectorAll ? scope : document;
      var panels = root.querySelectorAll('.about-why__inner');

      Array.prototype.forEach.call(panels, function (panel) {
        if (panel.dataset.whyBound === '1') return;
        panel.dataset.whyBound = '1';

        if (!('IntersectionObserver' in window)) {
          panel.classList.add('is-in');
          return;
        }

        var io = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                panel.classList.add('is-in');
                io.disconnect();
              }
            });
          },
          { threshold: 0.2 }
        );

        io.observe(panel);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        gate(document);
      });
    } else {
      gate(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      gate(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ai-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var panel = document.querySelector('[data-ai-engine]');
    if (!panel) return;

    var typed = panel.querySelector('[data-ai-typed]');
    var rows = [].slice.call(panel.querySelectorAll('.ai-hero__row'));
    var counter = panel.querySelector('[data-ai-count]');
    var triggers = (panel.getAttribute('data-triggers') || '').split('|').filter(Boolean);
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (!triggers.length || !rows.length) return;

    var timers = [];
    function later(fn, ms) { timers.push(setTimeout(fn, ms)); }
    function clearAll() { timers.forEach(clearTimeout); timers = []; }

    function reset() {
      rows.forEach(function (r) { r.classList.remove('is-writing', 'is-done'); });
      if (counter) counter.textContent = '0';
      if (typed) typed.textContent = '';
    }

    function typeTrigger(text, done) {
      var i = 0;
      (function step() {
        typed.textContent = text.slice(0, ++i);
        if (i < text.length) later(step, 34);
        else later(done, 500);
      })();
    }

    function runRows(done) {
      var n = 0;
      (function step() {
        if (n >= rows.length) { later(done, 2200); return; }
        var row = rows[n];
        row.classList.add('is-writing');
        later(function () {
          row.classList.remove('is-writing');
          row.classList.add('is-done');
          n++;
          if (counter) counter.textContent = String(n);
          later(step, 240);
        }, 1150);
      })();
    }

    var triggerIndex = 0;
    function cycle() {
      reset();
      var text = triggers[triggerIndex % triggers.length];
      triggerIndex++;
      typeTrigger(text, function () {
        runRows(cycle);
      });
    }

    // Reduced motion gets the finished state, not the loop.
    if (reduce) {
      typed.textContent = triggers[0];
      rows.forEach(function (r) { r.classList.add('is-done'); });
      if (counter) counter.textContent = String(rows.length);
      return;
    }

    var started = false;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting && !started) {
          started = true;
          cycle();
        } else if (!e.isIntersecting && started) {
          started = false;
          clearAll();
          reset();
        }
      });
    }, { threshold: 0.25 });
    io.observe(panel);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ai-stack"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var wrap = document.querySelector('[data-ai-constellation]');
    if (!wrap) return;

    var svg = wrap.querySelector('.sc-lines');
    var nodes = [].slice.call(wrap.querySelectorAll('.sc-node')).filter(function (n) {
      return !n.classList.contains('sc-core');
    });
    if (!nodes.length) return;

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var SVGNS = 'http://www.w3.org/2000/svg';
    var charges = [];

    nodes.forEach(function (n) {
      var x = n.getAttribute('data-x');
      var y = n.getAttribute('data-y');
      n.style.left = x + '%';
      n.style.top = y + '%';

      var base = document.createElementNS(SVGNS, 'line');
      base.setAttribute('x1', 50);
      base.setAttribute('y1', 50);
      base.setAttribute('x2', x);
      base.setAttribute('y2', y);
      base.setAttribute('class', 'sc-spoke');
      svg.appendChild(base);

      var ch = document.createElementNS(SVGNS, 'line');
      ch.setAttribute('x1', 50);
      ch.setAttribute('y1', 50);
      ch.setAttribute('x2', x);
      ch.setAttribute('y2', y);
      ch.setAttribute('class', 'sc-charge');
      ch.setAttribute('pathLength', '1');
      svg.appendChild(ch);
      charges.push(ch);
    });

    // Alternate inner and outer ring so the sequence reads as a circuit filling in,
    // not a clock hand sweeping. Any index past the node count is skipped, so the
    // order survives a merchant adding or removing a node.
    var order = [0, 6, 2, 9, 4, 7, 1, 8, 3, 5];
    var timers = [];
    var loopId = null;

    function clearAll() {
      timers.forEach(clearTimeout);
      timers = [];
    }

    function reset() {
      nodes.forEach(function (n) { n.classList.remove('lit'); });
      charges.forEach(function (c) { c.classList.remove('on'); });
    }

    function runCycle() {
      clearAll();
      reset();
      var seq = 0;
      order.forEach(function (idx) {
        if (idx >= nodes.length) return;
        var t = 260 + seq * 200;
        seq++;
        timers.push(setTimeout(function () { charges[idx].classList.add('on'); }, t));
        timers.push(setTimeout(function () { nodes[idx].classList.add('lit'); }, t + 360));
      });
      // Any node the order array does not name still lights, so none is left dark.
      nodes.forEach(function (n, i) {
        if (order.indexOf(i) !== -1) return;
        var t = 260 + seq * 200;
        seq++;
        timers.push(setTimeout(function () { charges[i].classList.add('on'); }, t));
        timers.push(setTimeout(function () { n.classList.add('lit'); }, t + 360));
      });
    }

    function play() {
      if (reduce) {
        nodes.forEach(function (n) { n.classList.add('lit'); });
        charges.forEach(function (c) { c.classList.add('on'); });
        return;
      }
      if (loopId) return;
      runCycle();
      loopId = setInterval(runCycle, 4600);
    }

    function stop() {
      if (loopId) {
        clearInterval(loopId);
        loopId = null;
      }
      clearAll();
    }

    if (!('IntersectionObserver' in window)) {
      play();
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { play(); } else { stop(); }
      });
    }, { threshold: 0.3 });
    io.observe(wrap);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["beastmode-results"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function fmt(v, dec, comma, prefix) {
      var s = comma ? (dec > 0 ? v.toLocaleString('en-US', { minimumFractionDigits: dec, maximumFractionDigits: dec }) : Math.round(v).toLocaleString('en-US')) : v.toFixed(dec);
      return prefix + s;
    }
    function ease(p) { return 1 - Math.pow(1 - p, 3); }
    function animate(el) {
      var target = parseFloat(el.getAttribute('data-count-target')) || 0;
      var dec = parseInt(el.getAttribute('data-count-dec') || '0', 10);
      var prefix = el.getAttribute('data-count-prefix') || '';
      var comma = el.getAttribute('data-count-comma') === '1';
      if (reduce) { el.textContent = fmt(target, dec, comma, prefix); return; }
      var dur = 1500, start = null;
      function step(ts) { if (start === null) start = ts; var p = Math.min(1, (ts - start) / dur); el.textContent = fmt(target * ease(p), dec, comma, prefix); if (p < 1) requestAnimationFrame(step); else el.textContent = fmt(target, dec, comma, prefix); }
      requestAnimationFrame(step);
    }
    document.querySelectorAll('.bm-results__stats').forEach(function (group) {
      var counters = group.querySelectorAll('.js-count-bm');
      if (!counters.length) return;
      counters.forEach(function (el) { el.textContent = fmt(0, parseInt(el.getAttribute('data-count-dec') || '0', 10), el.getAttribute('data-count-comma') === '1', el.getAttribute('data-count-prefix') || ''); });
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) { entries.forEach(function (e) { if (e.isIntersecting) { counters.forEach(animate); io.disconnect(); } }); }, { threshold: 0.2 });
        io.observe(group);
      } else { counters.forEach(animate); }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brand-consistency"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(viz) {
      if (viz.dataset.brandConsistencyBound === 'true') return;
      viz.dataset.brandConsistencyBound = 'true';

      var cards = Array.prototype.slice.call(viz.querySelectorAll('.brand-consistency__card'));
      var fill = viz.querySelector('[data-bc-fill]');
      var pct = viz.querySelector('[data-bc-pct]');
      if (cards.length === 0) return;

      var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var started = false;
      var timers = [];

      function T(fn, ms) {
        timers.push(setTimeout(fn, ms));
      }

      function setMeter(p) {
        if (fill) fill.style.width = p + '%';
        if (pct) pct.textContent = p + '%';
      }

      function reset() {
        timers.forEach(clearTimeout);
        timers = [];
        cards.forEach(function (c) { c.classList.remove('is-aligned'); });
        viz.classList.remove('is-consistent');
        setMeter(0);
      }

      function runOnce() {
        reset();
        var t = 700;
        cards.forEach(function (c, i) {
          T(function () {
            c.classList.add('is-aligned');
            setMeter(Math.round(((i + 1) / cards.length) * 100));
          }, t);
          t += 620;
        });
        T(function () { viz.classList.add('is-consistent'); }, t + 100);
        T(runOnce, t + 3200);
      }

      function start() {
        if (started) return;
        started = true;
        if (reduced) {
          cards.forEach(function (c) { c.classList.add('is-aligned'); });
          viz.classList.add('is-consistent');
          setMeter(100);
          return;
        }
        runOnce();
      }

      if (!('IntersectionObserver' in window)) {
        start();
        return;
      }

      new IntersectionObserver(function (entries, observer) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            start();
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.35 }).observe(viz);
    }

    function boot() {
      document.querySelectorAll('[data-brand-consistency]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brand-define"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(viz) {
      if (viz.dataset.brandAlignBound === 'true') return;
      viz.dataset.brandAlignBound = 'true';

      var arrows = Array.prototype.slice.call(viz.querySelectorAll('.brand-define__arrow'));
      var state = viz.querySelector('[data-align-state]');
      var caption = viz.querySelector('[data-align-caption]');
      if (arrows.length === 0) return;

      var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var started = false;
      var timer = null;

      function setCaption(aligned) {
        if (!caption) return;
        caption.textContent = '';
        if (aligned) {
          var text = caption.getAttribute('data-caption-aligned') || '';
          var accent = caption.getAttribute('data-caption-accent') || '';
          if (text) caption.appendChild(document.createTextNode(text + (accent ? ' ' : '')));
          if (accent) {
            var em = document.createElement('em');
            em.textContent = accent;
            caption.appendChild(em);
          }
        } else {
          caption.textContent = caption.getAttribute('data-caption') || '';
        }
      }

      function scatter() {
        arrows.forEach(function (a) {
          a.style.setProperty('--brand-align-r', Math.round(-160 + Math.random() * 320) + 'deg');
        });
        viz.classList.remove('is-aligned');
        if (state) state.textContent = state.getAttribute('data-scattered') || '';
        setCaption(false);
      }

      function align() {
        viz.classList.add('is-aligned');
        if (state) state.textContent = state.getAttribute('data-aligned') || '';
        setCaption(true);
      }

      function loop() {
        align();
        timer = setTimeout(function () {
          scatter();
          timer = setTimeout(loop, 1600);
        }, 2600);
      }

      function start() {
        if (started) return;
        started = true;
        scatter();
        if (reduced) {
          align();
          return;
        }
        setTimeout(loop, 900);
      }

      if (!('IntersectionObserver' in window)) {
        start();
        return;
      }

      new IntersectionObserver(function (entries, observer) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            start();
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.35 }).observe(viz);
    }

    function boot() {
      document.querySelectorAll('[data-brand-align]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brand-framework"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(track) {
      if (track.dataset.brandFrameworkBound === 'true') return;
      track.dataset.brandFrameworkBound = 'true';

      var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (reduced || !('IntersectionObserver' in window)) {
        track.classList.add('is-playing');
        return;
      }

      track.classList.add('is-armed');

      new IntersectionObserver(function (entries, observer) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          track.classList.remove('is-armed');
          track.classList.add('is-playing');
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.3 }).observe(track);
    }

    function boot() {
      document.querySelectorAll('[data-brand-framework]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brand-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(panel) {
      if (panel.dataset.brandClarityBound === 'true') return;
      panel.dataset.brandClarityBound = 'true';

      var state = panel.querySelector('[data-clarity-state]');
      var catEl = panel.querySelector('[data-clarity-cat]');
      var lineEl = panel.querySelector('[data-clarity-line]');
      var labelEl = panel.querySelector('[data-clarity-label]');
      var examples = Array.prototype.slice.call(panel.querySelectorAll('.brand-hero__example'));

      if (!catEl || !lineEl || examples.length === 0) return;

      var beforeText = labelEl ? labelEl.getAttribute('data-before') || (state ? state.textContent : '') : '';
      var afterText = labelEl ? labelEl.getAttribute('data-after') || beforeText : '';

      var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var started = false;
      var idx = 0;
      var timers = [];

      function T(fn, ms) {
        timers.push(setTimeout(fn, ms));
      }

      function setCase(i) {
        var el = examples[i % examples.length];
        catEl.textContent = el.getAttribute('data-cat') || '';

        var line = el.getAttribute('data-line') || '';
        var accent = el.getAttribute('data-accent') || '';
        var suffix = el.getAttribute('data-suffix') || '';

        lineEl.textContent = '';
        if (line) lineEl.appendChild(document.createTextNode(line + (accent ? ' ' : '')));
        if (accent) {
          var span = document.createElement('span');
          span.className = 'brand-hero__fill';
          span.textContent = accent;
          lineEl.appendChild(span);
        }
        if (suffix) lineEl.appendChild(document.createTextNode(suffix));
      }

      function toSharp() {
        panel.classList.add('is-sharp');
        if (state && afterText) state.textContent = afterText;
      }

      function toFuzz() {
        panel.classList.remove('is-sharp');
        if (state && beforeText) state.textContent = beforeText;
      }

      function loop() {
        timers.forEach(clearTimeout);
        timers = [];
        toFuzz();
        T(function () {
          setCase(idx);
          idx += 1;
          toSharp();
        }, 3400);
        T(loop, 8400);
      }

      function start() {
        if (started) return;
        started = true;
        if (reduced) {
          setCase(0);
          toSharp();
          return;
        }
        loop();
      }

      if (!('IntersectionObserver' in window)) {
        start();
        return;
      }

      new IntersectionObserver(function (entries, observer) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            start();
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.3 }).observe(panel);
    }

    function boot() {
      document.querySelectorAll('[data-brand-clarity]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brand-shows"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(stage) {
      if (stage.dataset.brandHubBound === 'true') return;
      stage.dataset.brandHubBound = 'true';

      var chips = Array.prototype.slice.call(stage.querySelectorAll('.brand-shows__chip'));
      var sigs = Array.prototype.slice.call(stage.querySelectorAll('.brand-shows__sig'));
      var counter = stage.querySelector('[data-hub-count]');
      if (chips.length === 0) return;

      var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var started = false;
      var timers = [];

      function T(fn, ms) {
        timers.push(setTimeout(fn, ms));
      }

      function reset() {
        timers.forEach(clearTimeout);
        timers = [];
        stage.classList.remove('is-running', 'is-complete');
        chips.forEach(function (c) { c.classList.remove('is-lit'); });
        if (counter) counter.textContent = '0';
        sigs.forEach(function (s) { s.style.animation = 'none'; });
        /* Force a reflow so the signal animation restarts on the next cycle. */
        void stage.offsetWidth;
        sigs.forEach(function (s) { s.style.animation = ''; });
      }

      function runOnce() {
        reset();
        var step = 300;
        void stage.offsetWidth;
        stage.classList.add('is-running');
        sigs.forEach(function (s, i) { s.style.animationDelay = (i * step) + 'ms'; });
        chips.forEach(function (c, i) {
          T(function () {
            c.classList.add('is-lit');
            if (counter) counter.textContent = String(i + 1);
          }, i * step + 700);
        });
        var total = (chips.length - 1) * step + 700;
        T(function () { stage.classList.add('is-complete'); }, total + 200);
        T(runOnce, total + 3400);
      }

      function start() {
        if (started) return;
        started = true;
        if (reduced) {
          chips.forEach(function (c) { c.classList.add('is-lit'); });
          stage.classList.add('is-complete');
          if (counter) counter.textContent = String(chips.length);
          return;
        }
        runOnce();
      }

      if (!('IntersectionObserver' in window)) {
        start();
        return;
      }

      new IntersectionObserver(function (entries, observer) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            start();
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.3 }).observe(stage);
    }

    function boot() {
      document.querySelectorAll('[data-brand-hub]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["case-approach"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    document.querySelectorAll('.case-approach__track').forEach(function (track) {
      if (reduce || !('IntersectionObserver' in window)) { track.classList.add('play'); return; }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { track.classList.add('play'); io.disconnect(); } });
      }, { threshold: 0.25 });
      io.observe(track);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["case-challenge"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function wire(list) {
      if (list.dataset.caseFunnelBound) return;
      list.dataset.caseFunnelBound = '1';
      var section = list.closest('.case-challenge-section');
      if (!section) return;
      var stage = section.querySelector('.case-challenge__media');
      var rows = Array.prototype.slice.call(list.querySelectorAll('.case-funnel__row'));
      var frames = stage ? Array.prototype.slice.call(stage.querySelectorAll('.case-challenge__frame')) : [];
      if (rows.length < 2 || frames.length < 2) return;

      var cur = 0;
      var timer = null;
      var pinned = false;

      function go(i) {
        cur = i;
        rows.forEach(function (r, j) {
          var on = j === i;
          r.classList.toggle('is-active', on);
          r.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        frames.forEach(function (f, j) { f.classList.toggle('is-active', j === i); });
      }

      function start() {
        if (timer || pinned || reduce) return;
        timer = setInterval(function () { go((cur + 1) % rows.length); }, 3500);
      }

      function stop() {
        if (timer) { clearInterval(timer); timer = null; }
      }

      rows.forEach(function (r, i) {
        function pick() { pinned = true; stop(); go(i); }
        r.addEventListener('click', pick);
        r.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); pick(); }
        });
      });

      go(0);

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { if (e.isIntersecting) { start(); } else { stop(); } });
        }, { threshold: 0.2 }).observe(list);
      } else {
        start();
      }
    }

    function boot() {
      document.querySelectorAll('[data-case-funnel]').forEach(wire);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["case-changed"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    document.querySelectorAll('.case-changed__list').forEach(function (list) {
      var rows = list.querySelectorAll('.case-changed__row');
      if (!rows.length) return;
      if (reduce || !('IntersectionObserver' in window)) {
        rows.forEach(function (r) { r.classList.add('in'); });
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          rows.forEach(function (r, i) { r.style.transitionDelay = (i * 110) + 'ms'; r.classList.add('in'); });
          io.disconnect();
        });
      }, { threshold: 0.15 });
      io.observe(list);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["case-email-row"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function wire(win) {
      var img = win.querySelector('.case-emailrow__img');
      if (!img) return;

      function update() {
        var travel = Math.round(img.getBoundingClientRect().height - win.clientHeight);
        if (travel > 2) {
          win.style.setProperty('--travel', (-travel) + 'px');
          // Constant scroll speed regardless of email height (~0.045s per px), floored.
          img.style.animationDuration = Math.max(22, Math.round(travel * 0.045)) + 's';
          win.classList.add('is-scrolling');
        } else {
          win.style.removeProperty('--travel');
          img.style.animationDuration = '';
          win.classList.remove('is-scrolling');
        }
      }

      if (img.complete && img.naturalHeight) update();
      img.addEventListener('load', update);
      if ('ResizeObserver' in window) new ResizeObserver(update).observe(win);
      setTimeout(update, 300);
      setTimeout(update, 1200);
    }

    document.querySelectorAll('.case-emailrow__win').forEach(wire);
  })();

  /* Mobile-only (<=700px): gently auto-scroll the email slider horizontally,
     one frame every 18s, ping-ponging at the ends. Pauses ~3.5s after a touch,
     and never runs for reduced-motion users. */
  (function () {
    var row = document.querySelector('.case-emailrow');
    if (!row) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var mq = window.matchMedia('(max-width: 700px)');
    var started = false, pos = null, dir = 1, userUntil = 0, last = null;

    row.addEventListener('touchstart', function () { userUntil = Date.now() + 3500; pos = null; }, { passive: true });

    function frameStep() {
      var first = row.querySelector('.case-emailrow__win');
      return (first ? first.getBoundingClientRect().width : row.clientWidth * 0.58) + 14;
    }

    function tick(ts) {
      if (!mq.matches) { started = false; return; }
      if (last === null) last = ts;
      var dt = ts - last; last = ts;
      var max = row.scrollWidth - row.clientWidth;
      if (max > 4 && Date.now() > userUntil) {
        if (pos === null || Math.abs(pos - row.scrollLeft) > 2) pos = row.scrollLeft;
        pos += dir * (frameStep() / 18000) * dt;
        if (pos >= max) { pos = max; dir = -1; }
        else if (pos <= 0) { pos = 0; dir = 1; }
        row.scrollLeft = pos;
      }
      requestAnimationFrame(tick);
    }

    function start() { if (!started) { started = true; last = null; requestAnimationFrame(tick); } }

    function onChange() { if (mq.matches) start(); }
    if (mq.addEventListener) mq.addEventListener('change', onChange); else if (mq.addListener) mq.addListener(onChange);
    if (mq.matches) start();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["case-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function format(value, dec, comma, prefix) {
      var s = comma
        ? (dec > 0
            ? value.toLocaleString('en-US', { minimumFractionDigits: dec, maximumFractionDigits: dec })
            : Math.round(value).toLocaleString('en-US'))
        : value.toFixed(dec);
      return prefix + s;
    }

    function easeOutCubic(p) {
      return 1 - Math.pow(1 - p, 3);
    }

    function animate(el) {
      var target = parseFloat(el.getAttribute('data-count-target')) || 0;
      var dec = parseInt(el.getAttribute('data-count-dec') || '0', 10);
      var prefix = el.getAttribute('data-count-prefix') || '';
      var comma = el.getAttribute('data-count-comma') === '1';

      if (reduce) {
        el.textContent = format(target, dec, comma, prefix);
        return;
      }

      var duration = 1500;
      var start = null;
      function step(ts) {
        if (start === null) start = ts;
        var p = Math.min(1, (ts - start) / duration);
        el.textContent = format(target * easeOutCubic(p), dec, comma, prefix);
        if (p < 1) requestAnimationFrame(step);
        else el.textContent = format(target, dec, comma, prefix);
      }
      requestAnimationFrame(step);
    }

    function run(scope) {
      var counters = scope.querySelectorAll('.js-count[data-count-target]');
      if (!counters.length) return;
      counters.forEach(function (el) {
        el.textContent = format(0, parseInt(el.getAttribute('data-count-dec') || '0', 10), el.getAttribute('data-count-comma') === '1', el.getAttribute('data-count-prefix') || '');
      });

      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) {
              counters.forEach(animate);
              io.disconnect();
            }
          });
        }, { threshold: 0.2 });
        io.observe(scope);
      } else {
        counters.forEach(animate);
      }
    }

    document.querySelectorAll('.case-hero__stats').forEach(run);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["case-results"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function fmt(v, dec, comma, prefix) {
      var s = comma ? (dec > 0 ? v.toLocaleString('en-US', { minimumFractionDigits: dec, maximumFractionDigits: dec }) : Math.round(v).toLocaleString('en-US')) : v.toFixed(dec);
      return prefix + s;
    }
    function ease(p) { return 1 - Math.pow(1 - p, 3); }
    function animate(el) {
      var target = parseFloat(el.getAttribute('data-count-target')) || 0;
      var dec = parseInt(el.getAttribute('data-count-dec') || '0', 10);
      var prefix = el.getAttribute('data-count-prefix') || '';
      var comma = el.getAttribute('data-count-comma') === '1';
      if (reduce) { el.textContent = fmt(target, dec, comma, prefix); return; }
      var dur = 1500, start = null;
      function step(ts) { if (start === null) start = ts; var p = Math.min(1, (ts - start) / dur); el.textContent = fmt(target * ease(p), dec, comma, prefix); if (p < 1) requestAnimationFrame(step); else el.textContent = fmt(target, dec, comma, prefix); }
      requestAnimationFrame(step);
    }
    document.querySelectorAll('.case-results__stats').forEach(function (group) {
      var counters = group.querySelectorAll('.js-count-r');
      if (!counters.length) return;
      counters.forEach(function (el) { el.textContent = fmt(0, parseInt(el.getAttribute('data-count-dec') || '0', 10), el.getAttribute('data-count-comma') === '1', el.getAttribute('data-count-prefix') || ''); });
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) { entries.forEach(function (e) { if (e.isIntersecting) { counters.forEach(animate); io.disconnect(); } }); }, { threshold: 0.2 });
        io.observe(group);
      } else { counters.forEach(animate); }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["case-workstream"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var EASE_REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function revealChecks(list) {
      if (list.dataset.wsChecksBound) return;
      list.dataset.wsChecksBound = '1';
      var rows = list.querySelectorAll('.case-ws__check-row');
      if (!rows.length) return;
      if (EASE_REDUCE || !('IntersectionObserver' in window)) {
        rows.forEach(function (r) { r.classList.add('in'); });
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          io.disconnect();
          rows.forEach(function (row, i) {
            var d = i * 140;
            row.style.transitionDelay = d + 'ms';
            var tick = row.querySelector('.case-ws__tick');
            if (tick) tick.style.transitionDelay = (d + 380) + 'ms';
            requestAnimationFrame(function () { row.classList.add('in'); });
          });
        });
      }, { threshold: 0.25 });
      io.observe(list);
    }

    function wireFader(grid) {
      if (grid.dataset.wsFaderBound) return;
      grid.dataset.wsFaderBound = '1';
      var shots = Array.prototype.slice.call(grid.querySelectorAll('.case-ws__shot'));
      if (shots.length !== 2) return;
      var toggle = document.querySelector('.case-ws__toggle[data-ws-toggle-for="' + grid.getAttribute('data-ws-fader') + '"]');
      var btns = toggle ? Array.prototype.slice.call(toggle.querySelectorAll('button')) : [];
      var cur = 0;
      var timer = null;
      var pinned = false;

      function go(i) {
        cur = i;
        shots.forEach(function (s, j) { s.classList.toggle('show', j === i); });
        btns.forEach(function (b, j) { b.classList.toggle('on', j === i); });
      }

      function start() {
        if (timer || pinned || EASE_REDUCE) return;
        timer = setInterval(function () { go((cur + 1) % 2); }, 4000);
      }

      function stop() {
        if (timer) { clearInterval(timer); timer = null; }
      }

      btns.forEach(function (b, i) {
        b.addEventListener('click', function () { pinned = true; stop(); go(i); });
      });

      go(0);

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { if (e.isIntersecting) { start(); } else { stop(); } });
        }, { threshold: 0.2 }).observe(grid);
      } else {
        start();
      }
    }

    /* The pan distance is the overflow of the decoded image beyond its window,
       so it can only be measured once the image has a real height. Measure on
       load (capture phase — load does not bubble) plus delayed re-checks for
       cached decodes that beat the listener. */
    function wireEmailWindow(win) {
      if (win.dataset.wsEmailBound) return;
      win.dataset.wsEmailBound = '1';
      var img = win.querySelector('.case-ws__email');
      if (!img) return;

      /* Two conditions, both required. `measured` means we know the pan distance;
         `seen` means the window has actually reached the viewport. Measuring can
         happen well before the reader gets here, and starting then meant the
         window was already part-way down by the time it was looked at. */
      var measured = false;
      var seen = false;

      function apply() {
        if (measured && seen) win.classList.add('is-scrolling');
      }

      function update() {
        var overflow = img.offsetHeight - win.offsetHeight;
        if (overflow > 8) {
          win.style.setProperty('--travel', (-overflow) + 'px');
          measured = true;
        } else {
          measured = false;
          win.classList.remove('is-scrolling');
        }
        apply();
      }

      watchOnce(win, function () { seen = true; apply(); });

      img.addEventListener('load', update, true);
      update();
      setTimeout(update, 300);
      setTimeout(update, 1200);
      window.addEventListener('resize', update);
    }

    function countStats(scope) {
      var counters = scope.querySelectorAll('.js-ws-count[data-count-target]');
      if (!counters.length) return;

      function format(value, dec, comma, prefix) {
        var s = comma
          ? (dec > 0
              ? value.toLocaleString('en-US', { minimumFractionDigits: dec, maximumFractionDigits: dec })
              : Math.round(value).toLocaleString('en-US'))
          : value.toFixed(dec);
        return prefix + s;
      }

      function read(el) {
        return {
          target: parseFloat(el.getAttribute('data-count-target')) || 0,
          dec: parseInt(el.getAttribute('data-count-dec') || '0', 10),
          prefix: el.getAttribute('data-count-prefix') || '',
          comma: el.getAttribute('data-count-comma') === '1'
        };
      }

      function animate(el) {
        var o = read(el);
        if (EASE_REDUCE) {
          el.textContent = format(o.target, o.dec, o.comma, o.prefix);
          return;
        }
        var duration = 1500;
        var start = null;
        function step(ts) {
          if (start === null) start = ts;
          var p = Math.min(1, (ts - start) / duration);
          el.textContent = format(o.target * (1 - Math.pow(1 - p, 3)), o.dec, o.comma, o.prefix);
          if (p < 1) requestAnimationFrame(step);
          else el.textContent = format(o.target, o.dec, o.comma, o.prefix);
        }
        requestAnimationFrame(step);
      }

      counters.forEach(function (el) {
        var o = read(el);
        el.textContent = format(0, o.dec, o.comma, o.prefix);
      });

      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) {
              counters.forEach(animate);
              io.disconnect();
            }
          });
        }, { threshold: 0.2 });
        io.observe(scope);
      } else {
        counters.forEach(animate);
      }
    }

    /* Slow pan for the shot boxes. Travels the FULL overflow so the pan reaches
       the bottom of the screenshot, then returns — the keyframes run
       0 -> travel -> 0, so one cycle is down and back up.

       The overflow is derived from the image's intrinsic ratio, NOT its laid-out
       height. The default rule crops with object-fit: cover and height: 100%, so
       offsetHeight is pinned to the box and measuring it would always report
       zero overflow. */
    /* Fires cb the first time el reaches the viewport, then stops watching.
       Deliberately one-shot: re-arming on every pass would restart the pan from
       the top each time the reader scrolled past, which reads as a glitch. */
    function watchOnce(el, cb) {
      if (!('IntersectionObserver' in window)) { cb(); return; }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          io.disconnect();
          cb();
        });
      }, { threshold: 0.2 });
      io.observe(el);
    }

    var SHOT_TRAVEL = 1;
    var SHOT_MIN_OVERFLOW = 24;

    function wireShotScroll(shot) {
      if (shot.dataset.wsShotBound) return;
      shot.dataset.wsShotBound = '1';
      var img = shot.querySelector('img');
      if (!img) return;

      /* Same two-condition gate as the email windows: measured AND on screen. */
      var measured = false;
      var seen = false;

      function apply() {
        if (measured && seen) shot.classList.add('is-scrolling');
      }

      function update() {
        if (!img.naturalWidth || !img.naturalHeight) return;
        var fullH = shot.offsetWidth * (img.naturalHeight / img.naturalWidth);
        var overflow = fullH - shot.offsetHeight;
        if (overflow > SHOT_MIN_OVERFLOW) {
          shot.style.setProperty('--shot-travel', (-(overflow * SHOT_TRAVEL)).toFixed(1) + 'px');
          measured = true;
        } else {
          measured = false;
          shot.classList.remove('is-scrolling');
          shot.style.removeProperty('--shot-travel');
        }
        apply();
      }

      watchOnce(shot, function () { seen = true; apply(); });

      /* Capture phase: load does not bubble. The delayed re-checks cover cached
         decodes that land before the listener is attached. */
      img.addEventListener('load', update, true);
      update();
      setTimeout(update, 300);
      setTimeout(update, 1200);
      window.addEventListener('resize', update);
    }

    function boot() {
      document.querySelectorAll('.case-ws__checks').forEach(revealChecks);
      document.querySelectorAll('[data-ws-fader]').forEach(wireFader);
      document.querySelectorAll('.case-ws__win').forEach(wireEmailWindow);
      document.querySelectorAll('.case-ws__shot').forEach(wireShotScroll);
      document.querySelectorAll('.case-ws__stats').forEach(countStats);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', boot);
  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.contact-form-section form').forEach(function (form) {
      form.addEventListener('submit', function (event) {
        var honeypot = form.querySelector('#contact-hp');
        if (!honeypot) return;

        if (honeypot.value !== '') {
          event.preventDefault();
          return;
        }

        honeypot.disabled = true;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["content-campaign"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(app) {
      if (app.dataset.campaignStackBound === 'true') return;
      app.dataset.campaignStackBound = 'true';

      var screens = Array.prototype.slice.call(app.querySelectorAll('[data-campaign-screen]'));
      var chips = Array.prototype.slice.call(app.querySelectorAll('[data-campaign-chip]'));

      if (screens.length === 0) return;

      var index = 0;
      var timer = null;

      function show(next) {
        index = (next + screens.length) % screens.length;
        screens.forEach(function (s, n) {
          s.classList.toggle('is-active', n === index);
        });
        chips.forEach(function (c, n) {
          var on = n === index;
          c.classList.toggle('is-active', on);
          c.setAttribute('aria-selected', on ? 'true' : 'false');
        });
      }

      function stop() {
        if (timer) {
          clearInterval(timer);
          timer = null;
        }
      }

      function start() {
        if (!timer) timer = setInterval(function () {
          show(index + 1);
        }, 3200);
      }

      /* Clicking a chip is a deliberate choice, so it wins over the auto-advance:
         restart the clock from that card rather than letting the old interval fire
         a few hundred ms later and yank the panel forward. */
      chips.forEach(function (chip, n) {
        chip.addEventListener('click', function () {
          stop();
          show(n);
          start();
        });

        chip.addEventListener('keydown', function (e) {
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
          e.preventDefault();
          var next = e.key === 'ArrowRight' ? n + 1 : n - 1;
          next = (next + chips.length) % chips.length;
          stop();
          show(next);
          start();
          chips[next].focus();
        });
      });

      var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduced) return;

      if (typeof IntersectionObserver !== 'function') {
        start();
        return;
      }

      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) start();
            else stop();
          });
        },
        { threshold: 0.25 }
      );

      io.observe(app);
    }

    function boot() {
      document.querySelectorAll('[data-campaign-stack]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["content-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(panel) {
      if (panel.dataset.contentEngineBound === 'true') return;
      panel.dataset.contentEngineBound = 'true';

      var typed = panel.querySelector('[data-engine-typed]');
      var counter = panel.querySelector('[data-engine-count]');
      var rows = Array.prototype.slice.call(panel.querySelectorAll('[data-engine-row]'));

      if (!typed || rows.length === 0) return;

      var raw = typed.getAttribute('data-ideas') || '';
      var ideas = raw
        .split('\n')
        .map(function (s) {
          return s.trim();
        })
        .filter(Boolean);

      if (ideas.length === 0) ideas = [typed.textContent.trim()];

      var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function finish() {
        typed.textContent = ideas[0];
        rows.forEach(function (r) {
          r.classList.add('is-done');
        });
        if (counter) counter.textContent = String(rows.length);
      }

      if (reduced) {
        finish();
        return;
      }

      var timers = [];

      function T(fn, ms) {
        timers.push(setTimeout(fn, ms));
      }

      function clearAll() {
        timers.forEach(clearTimeout);
        timers = [];
      }

      function reset() {
        rows.forEach(function (r) {
          r.classList.remove('is-writing', 'is-done');
        });
        if (counter) counter.textContent = '0';
        typed.textContent = '';
      }

      function typeIdea(text, done) {
        var i = 0;
        (function step() {
          typed.textContent = text.slice(0, ++i);
          if (i < text.length) T(step, 34);
          else T(done, 500);
        })();
      }

      function buildRows(done) {
        var n = 0;
        (function step() {
          if (n >= rows.length) {
            T(done, 2200);
            return;
          }
          var row = rows[n];
          row.classList.add('is-writing');
          T(function () {
            row.classList.remove('is-writing');
            row.classList.add('is-done');
            n++;
            if (counter) counter.textContent = String(n);
            T(step, 240);
          }, 1150);
        })();
      }

      var ideaIndex = 0;

      function cycle() {
        reset();
        var text = ideas[ideaIndex % ideas.length];
        ideaIndex++;
        typeIdea(text, function () {
          buildRows(cycle);
        });
      }

      /* IntersectionObserver does not fire reliably in the theme editor preview pane
         (documented in HANDOFF). Fall back to running immediately when it is absent,
         so the panel is never a dead rectangle. */
      if (typeof IntersectionObserver !== 'function') {
        cycle();
        return;
      }

      var started = false;
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting && !started) {
              started = true;
              cycle();
            } else if (!e.isIntersecting && started) {
              started = false;
              clearAll();
            }
          });
        },
        { threshold: 0.2 }
      );

      io.observe(panel);
    }

    function boot() {
      document.querySelectorAll('[data-content-engine]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["content-why"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(doc) {
      if (doc.dataset.contentDocBound === 'true') return;
      doc.dataset.contentDocBound = 'true';

      /* No observer available (older browser, or the editor preview pane where IO is
         unreliable — see HANDOFF): just play, rather than leave a frozen card. */
      if (typeof IntersectionObserver !== 'function') {
        doc.classList.add('is-playing');
        return;
      }

      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            doc.classList.toggle('is-playing', e.isIntersecting);
          });
        },
        { threshold: 0.2 }
      );

      io.observe(doc);
    }

    function boot() {
      document.querySelectorAll('[data-content-doc]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["content-work-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.gridTabsBound === 'true') return;
      root.dataset.gridTabsBound = 'true';

      var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-grid-tab]'));
      var panels = Array.prototype.slice.call(root.querySelectorAll('[data-grid-panel]'));

      if (tabs.length === 0 || panels.length === 0) return;

      function show(i) {
        var next = (i + tabs.length) % tabs.length;
        tabs.forEach(function (t, n) {
          var on = n === next;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        panels.forEach(function (p, n) {
          p.classList.toggle('is-active', n === next);
        });
        return next;
      }

      tabs.forEach(function (tab, n) {
        tab.addEventListener('click', function () {
          show(n);
        });

        tab.addEventListener('keydown', function (e) {
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
          e.preventDefault();
          var next = show(e.key === 'ArrowRight' ? n + 1 : n - 1);
          tabs[next].focus();
        });
      });
    }

    function boot() {
      document.querySelectorAll('.content-grid').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["content-work"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.workTabsBound === 'true') return;
      root.dataset.workTabsBound = 'true';

      var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-work-tab]'));
      var panels = Array.prototype.slice.call(root.querySelectorAll('[data-work-panel]'));

      if (tabs.length === 0 || panels.length === 0) return;

      function show(i) {
        var next = (i + tabs.length) % tabs.length;
        tabs.forEach(function (t, n) {
          var on = n === next;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        panels.forEach(function (p, n) {
          p.classList.toggle('is-active', n === next);
        });
        return next;
      }

      tabs.forEach(function (tab, n) {
        tab.addEventListener('click', function () {
          show(n);
        });

        tab.addEventListener('keydown', function (e) {
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
          e.preventDefault();
          var next = show(e.key === 'ArrowRight' ? n + 1 : n - 1);
          tabs[next].focus();
        });
      });
    }

    function boot() {
      document.querySelectorAll('.content-work').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["devcro-builds"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var rail = document.getElementById('buildsRail');
    var track = document.getElementById('buildsTrack');
    if (!rail || !track) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) return;
    var x = 0, speed = 0.5, raf;
    function gapPx() { return parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 22; }
    function rotate() {
      var first = track.firstElementChild;
      if (!first) return;
      var g = gapPx();
      var w = first.getBoundingClientRect().width + g;
      while (-x >= w) { track.appendChild(first); x += w; first = track.firstElementChild; w = first.getBoundingClientRect().width + g; }
      while (x > 0) { var last = track.lastElementChild; track.insertBefore(last, track.firstElementChild); x -= (last.getBoundingClientRect().width + g); }
    }
    function step() { x -= speed; rotate(); track.style.transform = 'translateX(' + x + 'px)'; raf = requestAnimationFrame(step); }
    raf = requestAnimationFrame(step);
  })();

  (function () {
    var speed = 75; // px/sec, steady across all cards
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function setup(scrollEl) {
      var img = scrollEl.querySelector('img');
      var vp = scrollEl.parentElement;
      if (!img || !vp) return;
      function tryInit() {
        if (!img.naturalWidth) return false;
        var key = (img.currentSrc || img.src) + '|' + img.naturalWidth + 'x' + img.naturalHeight + '|' + vp.clientWidth + 'x' + vp.clientHeight;
        if (scrollEl._key === key) return true;
        scrollEl._key = key;
        var vpW = vp.clientWidth, vpH = vp.clientHeight;
        var fullH = vpW * img.naturalHeight / img.naturalWidth;
        if (scrollEl._anim) { scrollEl._anim.cancel(); scrollEl._anim = null; }
        if (fullH <= vpH + 4) { scrollEl.style.height = '100%'; scrollEl.style.transform = 'translateY(0)'; return true; }
        scrollEl.style.height = fullH + 'px';
        var dist = fullH - vpH;
        if (reduce) { scrollEl.style.transform = 'translateY(0)'; return true; }
        var total = (dist / speed) * 1000 / 0.94;
        scrollEl._anim = scrollEl.animate([
          { transform: 'translateY(0)', offset: 0 },
          { transform: 'translateY(0)', offset: 0.03 },
          { transform: 'translateY(-' + dist + 'px)', offset: 0.97 },
          { transform: 'translateY(-' + dist + 'px)', offset: 1 }
        ], { duration: total, iterations: Infinity, easing: 'linear' });
        return true;
      }
      if (tryInit()) return;
      if (!img.complete) { img.addEventListener('load', tryInit); }
      var poll = setInterval(function () { if (tryInit()) { /* keep polling for src swaps */ } }, 800);
      scrollEl._poll = poll;
    }
    document.querySelectorAll('.devcro-builds__scroll').forEach(setup);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["devcro-framework"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var tracks = document.querySelectorAll('[data-devcro-framework]');
    if (!tracks.length) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    /* Arming hides the steps until the reveal runs. Without IntersectionObserver nothing
       would ever un-hide them, so leave the section in its finished state instead. */
    if (!('IntersectionObserver' in window)) return;

    tracks.forEach(function (track) {
      track.classList.add('is-armed');

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            track.classList.add('play');
            observer.disconnect();
          });
        },
        { threshold: 0.2 }
      );

      observer.observe(track);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["devcro-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var panel = document.getElementById('perfPanel');
    if (!panel) return;
    var line = panel.querySelector('.devcro-hero__chart-line');
    var lineLen = line ? line.getTotalLength() : 0;
    var fill = panel.querySelector('[data-perf-fill]');
    var status = panel.querySelector('[data-perf-status]');
    var counts = [].slice.call(panel.querySelectorAll('.devcro-hero__count'));
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var L = {
      before: panel.getAttribute('data-label-before') || 'Before Ultra',
      optimizing: panel.getAttribute('data-label-optimizing') || 'Optimizing',
      optimized: panel.getAttribute('data-label-optimized') || 'Optimized'
    };
    if (line) { line.style.strokeDasharray = lineLen; line.style.strokeDashoffset = lineLen; }
    var timers = [];
    function clr() { timers.forEach(clearTimeout); timers = []; }
    function fmt(el, v) { var d = parseInt(el.getAttribute('data-decimals') || '0', 10); return (el.getAttribute('data-prefix') || '') + v.toFixed(d) + (el.getAttribute('data-suffix') || ''); }
    function setFrom() { counts.forEach(function (el) { el.textContent = fmt(el, parseFloat(el.getAttribute('data-from')) || 0); }); }
    function setTo() { counts.forEach(function (el) { el.textContent = fmt(el, parseFloat(el.getAttribute('data-to')) || 0); }); }
    function countUp(el, dur, delay) {
      var from = parseFloat(el.getAttribute('data-from')) || 0, to = parseFloat(el.getAttribute('data-to')) || 0, t0 = null;
      function step(ts) { if (!t0) t0 = ts; var pr = Math.min((ts - t0) / dur, 1); var e = 1 - Math.pow(1 - pr, 3); el.textContent = fmt(el, from + (to - from) * e); if (pr < 1) requestAnimationFrame(step); else el.textContent = fmt(el, to); }
      timers.push(setTimeout(function () { requestAnimationFrame(step); }, delay));
    }
    function reset() {
      panel.classList.remove('optimizing', 'optimized');
      if (status) status.textContent = L.before;
      if (fill) { fill.style.transition = 'none'; fill.style.width = '0%'; }
      if (line) { line.style.transition = 'none'; line.style.strokeDashoffset = lineLen; }
      setFrom();
      void panel.offsetWidth;
    }
    function cycle() {
      clr(); reset();
      timers.push(setTimeout(function () {
        panel.classList.add('optimizing');
        if (status) status.textContent = L.optimizing;
        if (fill) { fill.style.transition = 'width 2400ms cubic-bezier(0.4,0,0.2,1)'; fill.style.width = '100%'; }
        if (line) { line.style.transition = 'stroke-dashoffset 2400ms cubic-bezier(0.4,0,0.2,1)'; line.style.strokeDashoffset = 0; }
        counts.forEach(function (el) { countUp(el, 2300, 150); });
      }, 2200));
      timers.push(setTimeout(function () {
        panel.classList.remove('optimizing'); panel.classList.add('optimized');
        if (status) status.textContent = L.optimized;
        setTo();
      }, 4750));
      timers.push(setTimeout(cycle, 9800));
    }
    function playStatic() { panel.classList.add('optimized'); if (status) status.textContent = L.optimized; if (fill) fill.style.width = '100%'; if (line) line.style.strokeDashoffset = 0; setTo(); }
    function start() { if (reduce) { playStatic(); return; } cycle(); }
    if (!('IntersectionObserver' in window)) { start(); return; }
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (e) { if (e.isIntersecting) { start(); io.disconnect(); } });
    }, { threshold: 0.4 });
    io.observe(panel);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["devcro-services"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var panel = document.getElementById('capAnim');
    if (!panel) return;
    var state = panel.querySelector('[data-ca-state]');
    var cap = panel.querySelector('[data-ca-cap]');
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var scatteredCap = panel.getAttribute('data-cap-scattered') || 'Point solutions, no system';
    var systemizedCap = panel.getAttribute('data-cap-systemized') || 'One connected growth system';
    var aligned = false, loopId = null;
    function toggle() {
      aligned = !aligned;
      panel.classList.toggle('aligned', aligned);
      if (state) state.textContent = aligned ? 'Systemized' : 'Scattered';
      if (cap) {
        cap.style.opacity = '0';
        setTimeout(function () { cap.textContent = aligned ? systemizedCap : scatteredCap; cap.style.opacity = '1'; }, 260);
      }
    }
    function play() {
      if (reduce) { panel.classList.add('aligned'); if (state) state.textContent = 'Systemized'; if (cap) cap.textContent = systemizedCap; return; }
      if (loopId) return;
      loopId = setInterval(toggle, 2600);
      setTimeout(toggle, 700);
    }
    function stop() { if (loopId) { clearInterval(loopId); loopId = null; } }
    if (!('IntersectionObserver' in window)) { play(); return; }
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (e) { if (e.isIntersecting) { play(); } else { stop(); } });
    }, { threshold: 0.3 });
    io.observe(panel);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["devcro-stack"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var wrap = document.getElementById('stackConstellation');
    if (!wrap) return;
    var svg = wrap.querySelector('.sc-lines');
    var nodes = [].slice.call(wrap.querySelectorAll('.sc-node')).filter(function (n) { return !n.classList.contains('sc-core'); });
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var SVGNS = 'http://www.w3.org/2000/svg';
    var charges = [];
    nodes.forEach(function (n) {
      var x = n.getAttribute('data-x'), y = n.getAttribute('data-y');
      n.style.left = x + '%'; n.style.top = y + '%';
      var base = document.createElementNS(SVGNS, 'line');
      base.setAttribute('x1', 50); base.setAttribute('y1', 50); base.setAttribute('x2', x); base.setAttribute('y2', y);
      base.setAttribute('class', 'sc-spoke');
      svg.appendChild(base);
      var ch = document.createElementNS(SVGNS, 'line');
      ch.setAttribute('x1', 50); ch.setAttribute('y1', 50); ch.setAttribute('x2', x); ch.setAttribute('y2', y);
      ch.setAttribute('class', 'sc-charge'); ch.setAttribute('pathLength', '1');
      svg.appendChild(ch);
      charges.push(ch);
    });
    var order = [0, 5, 1, 8, 2, 10, 3, 6, 4, 7, 9, 11];
    var timers = [], loopId = null;
    function clearAll() { timers.forEach(clearTimeout); timers = []; }
    function reset() { nodes.forEach(function (n) { n.classList.remove('lit'); }); charges.forEach(function (c) { c.classList.remove('on'); }); }
    function runCycle() {
      clearAll(); reset();
      order.forEach(function (idx, seq) {
        if (idx >= nodes.length) return;
        var t = 260 + seq * 200;
        timers.push(setTimeout(function () { charges[idx].classList.add('on'); }, t));
        timers.push(setTimeout(function () { nodes[idx].classList.add('lit'); }, t + 360));
      });
    }
    function play() {
      if (reduce) { nodes.forEach(function (n) { n.classList.add('lit'); }); charges.forEach(function (c) { c.classList.add('on'); }); return; }
      if (loopId) return;
      runCycle();
      loopId = setInterval(runCycle, 4600);
    }
    function stop() { if (loopId) { clearInterval(loopId); loopId = null; } clearAll(); }
    if (!('IntersectionObserver' in window)) { play(); return; }
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (e) { if (e.isIntersecting) { play(); } else { stop(); } });
    }, { threshold: 0.3 });
    io.observe(wrap);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["devcro-strategy"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var panel = document.getElementById('diagPanel');
    if (!panel) return;
    var line = panel.querySelector('.diag-line');
    var pct = panel.querySelector('[data-diag-pct]');
    var pins = [].slice.call(panel.querySelectorAll('.diag-pin'));
    var rows = [].slice.call(panel.querySelectorAll('.diag-prio'));
    var hlabel = panel.querySelector('[data-diag-label]');
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var times = [820, 1420, 2050, 2680];
    var resolveTimes = [3900, 4450, 5000, 5550];
    var timers = [];
    var loopId = null;
    function clearTimers() { timers.forEach(clearTimeout); timers = []; }
    function pinText(p, key) { var s = p.querySelector('span'); if (s && p.dataset[key]) s.textContent = p.dataset[key]; }
    function showAll() {
      pins.forEach(function (p) { p.classList.add('is-on', 'resolved'); pinText(p, 'good'); });
      rows.forEach(function (r) { r.classList.add('is-on', 'resolved'); });
      if (pct) pct.textContent = '100%';
      if (hlabel) hlabel.textContent = 'Issues resolved';
    }
    function reset() {
      pins.forEach(function (p) { p.classList.remove('is-on', 'resolved'); pinText(p, 'bad'); });
      rows.forEach(function (r) { r.classList.remove('is-on', 'resolved'); });
      if (pct) pct.textContent = '0%';
      if (hlabel) hlabel.textContent = 'Analyzing store';
    }
    function runCycle() {
      clearTimers();
      reset();
      if (line) { line.classList.remove('run'); void line.offsetWidth; line.classList.add('run'); }
      var start = Date.now();
      (function tick() {
        var t = Math.min(1, (Date.now() - start) / 3200);
        if (pct) pct.textContent = Math.round(t * 100) + '%';
        if (t < 1) { timers.push(setTimeout(tick, 60)); }
      })();
      pins.forEach(function (p, i) {
        timers.push(setTimeout(function () { p.classList.add('is-on'); if (rows[i]) rows[i].classList.add('is-on'); }, times[i]));
      });
      timers.push(setTimeout(function () { if (hlabel) hlabel.textContent = 'Applying fixes'; }, 3550));
      rows.forEach(function (r, i) {
        timers.push(setTimeout(function () {
          r.classList.add('resolved');
          if (pins[i]) { pins[i].classList.add('resolved'); pinText(pins[i], 'good'); }
        }, resolveTimes[i]));
      });
      timers.push(setTimeout(function () { if (hlabel) hlabel.textContent = 'Issues resolved'; }, 5800));
    }
    var running = false;
    function play() {
      if (reduce) { showAll(); return; }
      if (running) return;
      running = true;
      runCycle();
      loopId = setInterval(runCycle, 8600);
    }
    function stop() { running = false; clearTimers(); if (loopId) { clearInterval(loopId); loopId = null; } }
    if (!('IntersectionObserver' in window)) { play(); return; }
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (e) { if (e.isIntersecting) { play(); } else { stop(); } });
    }, { threshold: 0.3 });
    io.observe(panel);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ecomecon-referrals"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var cluster = document.querySelector('[data-ecomecon-cluster]');
    if (!cluster) return;
    var dots = Array.prototype.slice.call(cluster.querySelectorAll('.ecomecon-referrals__dot:not(.ecomecon-referrals__dot--hub)'));
    if (!dots.length) return;
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var started = false;
    function seed(i) { return (i * 2654435761) % 2147483647; }
    function lightOne(counter) {
      var unlit = dots.filter(function (d) { return !d.classList.contains('is-lit'); });
      if (!unlit.length) return;
      var d = unlit[seed(counter) % unlit.length];
      d.classList.add('is-lit');
      var hold = 2400 + (seed(counter + 7) % 2600);
      setTimeout(function () { d.classList.remove('is-lit'); }, hold);
    }
    function start() {
      if (started) return; started = true;
      if (reduced) { [0, 2, 4].forEach(function (i) { if (dots[i]) dots[i].classList.add('is-lit'); }); return; }
      var counter = 1;
      for (var k = 0; k < 3; k++) { (function (n) { setTimeout(function () { lightOne(n); }, n * 480); })(counter++); }
      setInterval(function () { lightOne(counter++); }, 900);
    }
    if (!('IntersectionObserver' in window)) { start(); return; }
    var io = new IntersectionObserver(function (en) { en.forEach(function (e) { if (e.isIntersecting) { start(); io.disconnect(); } }); }, { threshold: 0.3 });
    io.observe(cluster);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ecomecon-subscription"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var track = document.querySelector('[data-ecomecon-track]');
    if (!track) return;
    if (!('IntersectionObserver' in window)) { track.classList.add('is-playing'); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { track.classList.add('is-playing'); io.disconnect(); }
      });
    }, { threshold: 0.35 });
    io.observe(track);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-accordion"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.addEventListener('click', function (event) {
      var button = event.target.closest('.faq-item__question');
      if (!button) return;

      var item = button.closest('.faq-item');
      if (!item) return;

      var isOpen = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      item.classList.toggle('is-open', !isOpen);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-hero-split"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(panel) {
      if (!panel || panel.dataset.hqBound) return;
      panel.dataset.hqBound = '1';

      if (!('IntersectionObserver' in window)) {
        panel.classList.add('play');
        return;
      }

      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              panel.classList.add('play');
              io.disconnect();
            }
          });
        },
        { threshold: 0.25 }
      );

      io.observe(panel);
    }

    function boot() {
      document.querySelectorAll('[data-hq-panel]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  /* Feeds the sticky header its offset: the wrapper is pulled up by exactly the
     announcement bar's height so the bar scrolls off and the nav lands flush.
     Measured rather than hard-coded because the bar wraps at narrow widths. */
  (function () {
    function syncAnnouncementHeight() {
      var group = document.querySelector('.shopify-section-group-header-group');
      if (!group) return;
      var bar = document.querySelector('.announcement');
      group.style.setProperty('--ann-h', (bar ? bar.offsetHeight : 0) + 'px');
    }

    syncAnnouncementHeight();
    window.addEventListener('load', syncAnnouncementHeight);
    window.addEventListener('resize', syncAnnouncementHeight);
    document.addEventListener('shopify:section:load', syncAnnouncementHeight);
  })();

  // Mobile drawer: parent items expand in place. The desktop dropdown is
  // CSS-only (:hover / :focus-within), but touch has no hover, so the whole
  // parent row is a button that toggles the child list (and never navigates).
  document.querySelectorAll('.mobile-nav__parent').forEach(function (btn) {
    var item = btn.closest('li');
    var sub = item ? item.querySelector('.mobile-nav__sub') : null;
    if (!sub) return;

    btn.addEventListener('click', function () {
      var isOpen = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      sub.hidden = isOpen;
    });
  });

  document.querySelectorAll('.nav-toggle').forEach(function (btn) {
    var drawerId = btn.getAttribute('aria-controls');
    var drawer = drawerId ? document.getElementById(drawerId) : null;
    if (!drawer) return;
    var hideTimer;

    function open() {
      window.clearTimeout(hideTimer);
      drawer.hidden = false;
      void drawer.offsetWidth;
      drawer.classList.add('is-open');
      btn.classList.add('is-open');
      btn.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('nav-open');
    }

    function close() {
      drawer.classList.remove('is-open');
      btn.classList.remove('is-open');
      btn.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('nav-open');
      hideTimer = window.setTimeout(function () {
        drawer.hidden = true;
      }, 340);
    }

    btn.addEventListener('click', function () {
      if (btn.getAttribute('aria-expanded') === 'true') {
        close();
      } else {
        open();
      }
    });

    drawer.querySelectorAll('[data-close]').forEach(function (el) {
      el.addEventListener('click', function () {
        close();
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && btn.getAttribute('aria-expanded') === 'true') {
        close();
      }
    });
  });

  // Accent line treatment (headline orphan prevention, v2). When a heading
  // with an accent (<em>/<strong> as a direct child) wraps, the MULTI-WORD
  // accent phrase is dropped onto its own line — the designed look. A
  // ONE-WORD accent is never given its own line: that manufactures exactly
  // the single-word orphan this exists to prevent (e.g. "story." alone).
  // Those headings get text-wrap: balance instead, which keeps the accent
  // attached to the word before it. Also skipped: headings the author
  // hand-wrapped with a <br>, and mid-sentence accents, where a forced
  // break would split the thought ("Strong demand, / no engine…").
  // Lives here because the header renders on every page. This is the ONLY
  // copy — do not re-add the per-section clones this replaced.
  (function () {
    function apply() {
      var heads = document.querySelectorAll('h1, h2, h3');

      Array.prototype.forEach.call(heads, function (h) {
        var accent = null;
        for (var i = 0; i < h.children.length; i++) {
          var tag = h.children[i].tagName;
          if (tag === 'EM' || tag === 'STRONG') {
            accent = h.children[i];
            break;
          }
        }
        if (!accent) return;

        var marker = h.querySelector('br[data-em-break]');
        if (marker) marker.parentNode.removeChild(marker);

        // Respect an authored line break.
        if (h.querySelector('br')) return;

        var lh = parseFloat(getComputedStyle(h).lineHeight) || 0;
        if (!lh) return;

        var naturalLines = Math.round(h.offsetHeight / lh);
        if (naturalLines <= 1) return;

        // Text after the accent: a trailing "." / "?" is part of the accent
        // phrase; anything with letters means the accent sits mid-sentence.
        var trailing = '';
        for (var n = accent.nextSibling; n; n = n.nextSibling) {
          trailing += n.textContent || '';
        }
        var midSentence = /[A-Za-z0-9]/.test(trailing);

        var phrase = (accent.textContent + ' ' + trailing).trim();
        var phraseWords = phrase.split(/\s+/).filter(function (w) {
          return /[A-Za-z0-9]/.test(w);
        }).length;

        var pre = '';
        for (var p = h.firstChild; p && p !== accent; p = p.nextSibling) {
          pre += p.textContent || '';
        }
        var preWords = pre.trim().split(/\s+/).filter(function (w) {
          return /[A-Za-z0-9]/.test(w);
        }).length;

        if (!midSentence && phraseWords >= 2 && preWords >= 2) {
          var br = document.createElement('br');
          br.setAttribute('data-em-break', '');
          h.insertBefore(br, accent);
          // The break must produce a CLEAN accent line: no extra lines
          // overall, and the accent itself must not wrap (a wrapped accent
          // strands its last word alone — e.g. "infrastructure to /
          // revenue." in a narrow column). Otherwise balance does better.
          var accentWrapped = accent.getBoundingClientRect().height > lh * 1.5;
          if (Math.round(h.offsetHeight / lh) > naturalLines || accentWrapped) {
            h.removeChild(br);
            h.style.textWrap = 'balance';
          }
        } else {
          h.style.textWrap = 'balance';
        }
      });
    }

    apply();
    window.addEventListener('load', apply);

    var t;
    window.addEventListener('resize', function () {
      clearTimeout(t);
      t = setTimeout(apply, 150);
    });

    document.addEventListener('shopify:section:load', apply);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-banner"] && !Shopify.designMode) return;
  try {
    
  /* Client-site rail: a continuous loop, not a slider. Cards are recycled — the
     first is moved to the end once it has fully passed — so the strip never
     resets and works with any number of blocks without duplicating markup.

     Scoped per instance via data-attributes; the track's children are the
     .shopify-block wrappers Shopify emits around each block, so the rotation
     moves the WRAPPERS. Moving the inner .hero-site instead would orphan the
     wrappers and break the customizer's block selection. */
  (function () {
    function build(rail) {
      if (rail.dataset.heroRailBound === '1') return;
      rail.dataset.heroRailBound = '1';

      var track = rail.querySelector('[data-hero-rail-track]');
      if (!track || !track.children.length) return;

      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var raf = null, pos = 0, horizontal = null, visible = true;

      function gap() {
        var cs = getComputedStyle(track);
        return parseFloat(horizontal ? cs.columnGap : cs.rowGap) || 18;
      }

      function sizeOf(el) {
        var r = el.getBoundingClientRect();
        return (horizontal ? r.width : r.height) + gap();
      }

      function recycle() {
        var first = track.firstElementChild;
        if (!first) return;
        var s = sizeOf(first);
        /* Guard on s > 0: a card whose image has not laid out yet measures 0 and
           would spin this loop forever. */
        while (s > 0 && -pos >= s) {
          track.appendChild(first);
          pos += s;
          first = track.firstElementChild;
          s = sizeOf(first);
        }
        while (pos > 0) {
          var last = track.lastElementChild;
          track.insertBefore(last, track.firstElementChild);
          pos -= sizeOf(last);
        }
      }

      function frame() {
        pos += horizontal ? -0.45 : -0.34;
        recycle();
        track.style.transform = horizontal
          ? 'translateX(' + pos.toFixed(2) + 'px)'
          : 'translateY(' + pos.toFixed(2) + 'px)';
        raf = requestAnimationFrame(frame);
      }

      function stop() { if (raf) { cancelAnimationFrame(raf); raf = null; } }
      function play() { if (!raf && !reduce && visible) raf = requestAnimationFrame(frame); }

      function layout() {
        var h = window.innerWidth <= 1300;
        if (h === horizontal) return;
        horizontal = h;
        stop();
        pos = 0;
        track.style.transform = '';
        play();
      }

      layout();

      var t;
      window.addEventListener('resize', function () {
        clearTimeout(t);
        t = setTimeout(layout, 160);
      });

      /* Paused off-screen: this is a permanent rAF loop otherwise. */
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            visible = e.isIntersecting;
            if (visible) play(); else stop();
          });
        }, { threshold: 0 }).observe(rail);
      }
    }

    function init(scope) {
      (scope || document).querySelectorAll('[data-hero-rail]').forEach(build);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(); });
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ind-cpg"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function arm(track) {
      if (track.dataset.indJourneyBound) return;
      track.dataset.indJourneyBound = '1';
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var editor = window.Shopify && window.Shopify.designMode;
      if (reduce || editor || !('IntersectionObserver' in window)) { track.classList.add('is-play'); return; }
      track.classList.add('is-armed');
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { track.classList.add('is-play'); io.disconnect(); }
        });
      }, { threshold: 0.35 });
      io.observe(track);
    }
    function boot() { document.querySelectorAll('[data-ind-journey]').forEach(arm); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ind-scale"] && !Shopify.designMode) return;
  try {
    
  /* Lights a random unlit node every 900ms and lets it fade after 2.4 to 5s,
     only while the cluster is on screen. Reduced motion and the theme editor
     get a still frame with three nodes lit. */
  (function () {
    function wire(cluster) {
      if (cluster.dataset.indClusterBound) return;
      cluster.dataset.indClusterBound = '1';
      var dots = Array.prototype.slice.call(cluster.querySelectorAll('.ind-scale__dot:not(.ind-scale__dot--hub)'));
      var still = (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) ||
        (window.Shopify && window.Shopify.designMode);
      if (still || !('IntersectionObserver' in window)) {
        [0, 2, 4].forEach(function (i) { if (dots[i]) dots[i].classList.add('is-lit'); });
        return;
      }
      var timer = null;
      function lightRandom() {
        var unlit = dots.filter(function (d) { return !d.classList.contains('is-lit'); });
        if (!unlit.length) return;
        var d = unlit[Math.floor(Math.random() * unlit.length)];
        d.classList.add('is-lit');
        setTimeout(function () { d.classList.remove('is-lit'); }, 2400 + Math.random() * 2600);
      }
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting && !timer) {
            for (var k = 0; k < 3; k++) setTimeout(lightRandom, k * 480);
            timer = setInterval(lightRandom, 900);
          } else if (!e.isIntersecting && timer) {
            clearInterval(timer);
            timer = null;
          }
        });
      }, { threshold: 0.3 }).observe(cluster);
    }
    function boot() { document.querySelectorAll('[data-ind-cluster]').forEach(wire); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["klaviyo-campaigns"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var inboxes = document.querySelectorAll('[data-klaviyo-inbox]');
    if (!inboxes.length) return;

    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    inboxes.forEach(function (inbox) {
      var promos = Array.prototype.slice.call(inbox.querySelectorAll('.klaviyo-campaigns__row--promo'));
      var brand = inbox.querySelector('.klaviyo-campaigns__row--brand');
      if (!brand) return;

      var started = false;

      function T(fn, ms) {
        setTimeout(fn, ms);
      }

      function runOnce() {
        var t = 500;
        promos.forEach(function (row) {
          T(function () {
            row.classList.add('is-deleting');
          }, t);
          T(function () {
            row.classList.add('is-removed');
          }, t + 540);
          t += 1150;
        });
        T(function () {
          brand.classList.add('is-open');
        }, t + 350);
        T(function () {
          brand.classList.remove('is-open');
          T(function () {
            promos.forEach(function (row) {
              row.classList.remove('is-deleting');
              row.classList.remove('is-removed');
            });
            T(runOnce, 1600);
          }, 800);
        }, t + 350 + 3400);
      }

      function start() {
        if (started) return;
        started = true;
        if (reduced) {
          brand.classList.add('is-open');
          return;
        }
        runOnce();
      }

      if (!('IntersectionObserver' in window)) {
        start();
        return;
      }

      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              start();
              io.disconnect();
            }
          });
        },
        { threshold: 0.35 }
      );

      io.observe(inbox);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["klaviyo-flows"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.klaviyo-flows').forEach(function (root) {
      var rows = root.querySelectorAll('.klaviyo-flows__row[data-klaviyo-flow]');
      var groups = root.querySelectorAll('[data-klaviyo-flow-group]');
      var label = root.querySelector('[data-klaviyo-flow-label]');
      if (!rows.length || !groups.length) return;

      var labelSuffix = label ? label.textContent.split('—').pop().trim() : '';

      function select(row) {
        var id = row.getAttribute('data-klaviyo-flow');
        rows.forEach(function (r) {
          var on = r === row;
          r.classList.toggle('is-active', on);
          r.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        var title = '';
        groups.forEach(function (g) {
          var on = g.getAttribute('data-klaviyo-flow-group') === id;
          g.classList.toggle('is-active', on);
          if (on) title = g.getAttribute('data-title') || '';
        });
        if (label) label.textContent = title + ' — ' + labelSuffix;
      }

      rows.forEach(function (row) {
        row.addEventListener('click', function () {
          select(row);
        });
        row.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            select(row);
          }
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["klaviyo-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var panels = document.querySelectorAll('.klaviyo-hero__panel');
    if (!panels.length) return;

    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function settleOne(el) {
      var target = parseFloat(el.getAttribute('data-target'));
      if (isNaN(target)) return;
      el.textContent =
        (el.getAttribute('data-prefix') || '') +
        target.toFixed(parseInt(el.getAttribute('data-decimals'), 10) || 0) +
        (el.getAttribute('data-suffix') || '');
    }

    function countUp(el, delay) {
      var target = parseFloat(el.getAttribute('data-target'));
      if (isNaN(target)) return;
      var decimals = parseInt(el.getAttribute('data-decimals'), 10) || 0;
      var prefix = el.getAttribute('data-prefix') || '';
      var suffix = el.getAttribute('data-suffix') || '';
      var duration = 1300;
      var start = null;
      var done = false;

      function finish() {
        if (done) return;
        done = true;
        settleOne(el);
      }

      function frame(now) {
        if (done) return;
        if (start === null) start = now;
        var progress = Math.min((now - start) / duration, 1);
        if (progress >= 1) {
          finish();
          return;
        }
        var eased = 1 - Math.pow(1 - progress, 3);
        el.textContent = prefix + (target * eased).toFixed(decimals) + suffix;
        requestAnimationFrame(frame);
      }

      /* Backstop: requestAnimationFrame is throttled to a near-stop in background tabs,
         which would strand the figure at an arbitrary fraction of its value. The timer
         guarantees the true number is committed; finish() is idempotent. */
      setTimeout(finish, delay + duration + 200);
      setTimeout(function () {
        requestAnimationFrame(frame);
      }, delay);
    }

    /* The comet's travel distance depends on how many flow steps the merchant added,
       so it is measured from the rendered flow rather than hardcoded. */
    function measureTravel(panel) {
      var flow = panel.querySelector('.klaviyo-hero__flow');
      if (!flow) return;
      var travel = flow.offsetHeight - 34;
      if (travel > 0) {
        panel.style.setProperty('--klaviyo-hero-travel', travel + 'px');
      }
    }

    function settle(panel) {
      panel.querySelectorAll('.klaviyo-hero__count').forEach(settleOne);
    }

    var canObserve = 'IntersectionObserver' in window;

    panels.forEach(function (panel) {
      measureTravel(panel);
      window.addEventListener('resize', function () {
        measureTravel(panel);
      });

      if (reduced || !canObserve) {
        settle(panel);
        return;
      }

      panel.classList.add('is-armed');

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            panel.classList.add('play');
            var main = panel.querySelector('.klaviyo-hero__metric .klaviyo-hero__count');
            if (main) countUp(main, 250);
            panel.querySelectorAll('.klaviyo-hero__substats .klaviyo-hero__count').forEach(function (el) {
              countUp(el, 1550);
            });
            observer.disconnect();
          });
        },
        { threshold: 0.25 }
      );

      observer.observe(panel);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["klaviyo-journey"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var tracks = document.querySelectorAll('.klaviyo-journey__track');
    if (!tracks.length) return;

    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var canObserve = 'IntersectionObserver' in window;

    tracks.forEach(function (track) {
      if (reduced || !canObserve) {
        track.classList.add('play');
        return;
      }

      track.classList.add('is-armed');

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            track.classList.add('play');
            observer.disconnect();
          });
        },
        { threshold: 0.35 }
      );

      observer.observe(track);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["klaviyo-stack"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var clusters = document.querySelectorAll('[data-klaviyo-hex]');
    if (!clusters.length) return;

    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    clusters.forEach(function (cluster) {
      var dots = Array.prototype.slice.call(cluster.querySelectorAll('.klaviyo-stack__dot[data-has-logo]'));
      if (!dots.length) return;

      var started = false;

      function lightRandom() {
        var unlit = dots.filter(function (d) {
          return !d.classList.contains('is-lit');
        });
        if (!unlit.length) return;
        var d = unlit[Math.floor(Math.random() * unlit.length)];
        d.classList.add('is-lit');
        setTimeout(function () {
          d.classList.remove('is-lit');
        }, 2600 + Math.random() * 2800);
      }

      function start() {
        if (started) return;
        started = true;
        if (reduced) {
          dots.slice(0, 6).forEach(function (d) {
            d.classList.add('is-lit');
          });
          return;
        }
        for (var k = 0; k < 3; k++) setTimeout(lightRandom, k * 500);
        setInterval(lightRandom, 950);
      }

      if (!('IntersectionObserver' in window)) {
        start();
        return;
      }

      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              start();
              io.disconnect();
            }
          });
        },
        { threshold: 0.3 }
      );

      io.observe(cluster);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["klaviyo-strategy"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var scrollers = document.querySelectorAll('[data-klaviyo-phone-scroll]');
    var VIEWPORT_RATIO = 9 / 19.5;

    scrollers.forEach(function (scroller) {
      var img = scroller.querySelector('img');
      if (!img) return;

      function apply() {
        var w = img.naturalWidth;
        var h = img.naturalHeight;
        if (!w || !h) return;

        var heightPct = (h / w) * VIEWPORT_RATIO * 100;
        if (heightPct <= 100) {
          scroller.style.setProperty('--klaviyo-phone-scroll-height', '100%');
          scroller.style.setProperty('--klaviyo-phone-scroll-end', '0%');
          return;
        }

        scroller.style.setProperty('--klaviyo-phone-scroll-height', heightPct.toFixed(2) + '%');
        scroller.style.setProperty('--klaviyo-phone-scroll-end', (-(1 - 100 / heightPct) * 100).toFixed(2) + '%');
        if (!reduced) scroller.classList.add('is-animated');
      }

      if (img.complete) {
        apply();
      } else {
        img.addEventListener('load', apply, { once: true });
      }
    });

    var pops = document.querySelectorAll('.klaviyo-strategy__pops');
    if (!pops.length) return;

    var canObserve = 'IntersectionObserver' in window;

    pops.forEach(function (group) {
      if (reduced || !canObserve) return;

      group.classList.add('is-armed');

      var target = group.closest('.klaviyo-strategy__media') || group;
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            group.classList.add('play');
            observer.disconnect();
          });
        },
        { threshold: 0.35 }
      );

      observer.observe(target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews-wall"] && !Shopify.designMode) return;
  try {
    
  /* Phones show five reviews and reveal five more per tap.

     The collapse is applied by JS, never in Liquid: with it baked into the
     markup a reader without JS would be left with five reviews and a button
     that does nothing. Rendering everything and hiding it here means the
     no-JS case degrades to the full list. */
  (function () {
    var STEP = 5;

    function setup(wall) {
      if (wall.dataset.reviewsMoreBound === '1') return;
      wall.dataset.reviewsMoreBound = '1';

      var cards = Array.prototype.slice.call(wall.querySelectorAll('.reviews-wall__card'));
      var btn = wall.querySelector('[data-reviews-more]');
      if (!btn || cards.length <= STEP) return;

      var mq = window.matchMedia('(max-width: 700px)');
      var shown = STEP;

      function apply() {
        if (!mq.matches) {
          /* Desktop is a masonry of everything — leave no trace of the collapse. */
          cards.forEach(function (c) { c.removeAttribute('data-collapsed'); });
          btn.hidden = true;
          return;
        }
        cards.forEach(function (c, i) {
          if (i < shown) c.removeAttribute('data-collapsed');
          else c.setAttribute('data-collapsed', '');
        });
        btn.hidden = shown >= cards.length;
      }

      btn.addEventListener('click', function () {
        var first = cards[shown];
        shown += STEP;
        apply();
        /* Move focus to the first newly revealed card so a keyboard or screen
           reader user lands on the new content instead of a button that may
           have just disappeared. */
        if (first) {
          first.setAttribute('tabindex', '-1');
          first.focus({ preventScroll: true });
        }
      });

      /* Crossing the breakpoint resets the count — coming back to a phone
         mid-way through a desktop session should start from five again. */
      if (mq.addEventListener) mq.addEventListener('change', function () { shown = STEP; apply(); });
      else if (mq.addListener) mq.addListener(function () { shown = STEP; apply(); });

      apply();
    }

    function boot() {
      document.querySelectorAll('.reviews-wall').forEach(setup);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();

    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["services-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var panels = document.querySelectorAll('[data-diag-panel]');
    panels.forEach(function (panel) {
      if (panel.dataset.diagInit) return;
      panel.dataset.diagInit = '1';
      var rows = [].slice.call(panel.querySelectorAll('.services-hero__qrow'));
      var status = panel.querySelector('[data-diag-status]');
      var fill = panel.querySelector('[data-diag-fill]');
      var labelScan = status ? (status.getAttribute('data-label-scan') || 'Diagnosing') : 'Diagnosing';
      var labelFixed = status ? (status.getAttribute('data-label-fixed') || 'One System') : 'One System';
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var timers = [], started = false;
      function clr() { timers.forEach(clearTimeout); timers = []; }
      function reset() {
        panel.classList.remove('is-fixed');
        rows.forEach(function (r) { r.classList.remove('is-scan', 'is-flag', 'is-fixed'); });
        if (status) status.textContent = labelScan;
        if (fill) { fill.style.transition = 'none'; fill.style.width = '0%'; }
        void panel.offsetWidth;
      }
      function cycle() {
        clr(); reset();
        if (fill) { fill.style.transition = 'width 3400ms cubic-bezier(0.4,0,0.2,1)'; fill.style.width = '100%'; }
        rows.forEach(function (r, i) {
          var t = 500 + i * 620;
          timers.push(setTimeout(function () { r.classList.add('is-scan'); }, t));
          timers.push(setTimeout(function () { r.classList.remove('is-scan'); r.classList.add('is-flag'); }, t + 430));
        });
        var tFix = 500 + rows.length * 620 + 500;
        timers.push(setTimeout(function () {
          panel.classList.add('is-fixed');
          if (status) status.textContent = labelFixed;
          rows.forEach(function (r, i) {
            timers.push(setTimeout(function () { r.classList.add('is-fixed'); }, i * 130));
          });
        }, tFix));
        timers.push(setTimeout(cycle, tFix + 5200));
      }
      function playStatic() {
        panel.classList.add('is-fixed');
        if (status) status.textContent = labelFixed;
        rows.forEach(function (r) { r.classList.add('is-fixed'); });
        if (fill) fill.style.width = '100%';
      }
      function start() { if (started) return; started = true; if (reduce) { playStatic(); return; } cycle(); }
      if (!('IntersectionObserver' in window)) { start(); return; }
      var io = new IntersectionObserver(function (en) {
        en.forEach(function (e) { if (e.isIntersecting) { start(); io.disconnect(); } });
      }, { threshold: 0.4 });
      io.observe(panel);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["services-process"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var tracks = document.querySelectorAll('[data-journey-track]');
    if (!tracks.length) return;
    tracks.forEach(function (track) {
      if (track.dataset.journeyInit) return;
      track.dataset.journeyInit = '1';
      if (!('IntersectionObserver' in window)) { track.classList.add('play'); return; }
      var io = new IntersectionObserver(function (en) {
        en.forEach(function (e) { if (e.isIntersecting) { track.classList.add('play'); io.disconnect(); } });
      }, { threshold: 0.35 });
      io.observe(track);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["services-system"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var els = document.querySelectorAll('[data-stage-anim]');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('play'); });
      return;
    }
    els.forEach(function (el) {
      if (el.dataset.stageInit) return;
      el.dataset.stageInit = '1';
      var io = new IntersectionObserver(function (en) {
        en.forEach(function (e) { if (e.isIntersecting) { el.classList.add('play'); io.disconnect(); } });
      }, { threshold: 0.3 });
      io.observe(el);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["subopt-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var panel = document.querySelector('[data-subopt-panel]');
    if (!panel) return;

    var counter = panel.querySelector('[data-subopt-count]');
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function fmt(el, n) {
      var prefix = el.getAttribute('data-prefix') || '';
      var suffix = el.getAttribute('data-suffix') || '';
      el.textContent = prefix + n + suffix;
    }

    function countUp(el) {
      var target = parseInt(el.getAttribute('data-target'), 10);
      if (isNaN(target)) return;
      var start = null;
      var dur = 1500;
      function frame(t) {
        if (start === null) start = t;
        var p = Math.min((t - start) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        fmt(el, Math.round(eased * target));
        if (p < 1) requestAnimationFrame(frame);
      }
      requestAnimationFrame(frame);
    }

    if (reduce) {
      panel.classList.add('is-playing');
      if (counter) fmt(counter, parseInt(counter.getAttribute('data-target'), 10) || 0);
      return;
    }

    var started = false;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting && !started) {
          started = true;
          panel.classList.add('is-playing');
          if (counter) countUp(counter);
        }
      });
    }, { threshold: 0.35 });
    io.observe(panel);
    /* The observer can miss when the panel is already on screen as it binds
       (a re-render, a restored scroll position). Its children start at
       opacity 0, so a miss leaves the hero panel blank. */
    setTimeout(function () {
      if (started) return;
      var r = panel.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0) {
        started = true;
        panel.classList.add('is-playing');
        if (counter) countUp(counter);
      }
    }, 1200);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["subopt-lifecycle"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var tracks = document.querySelectorAll('[data-subopt-journey]');
    if (!tracks.length) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    tracks.forEach(function (track) {
      if (reduce) { track.classList.add('is-playing'); return; }
      if (!('IntersectionObserver' in window)) { track.classList.add('is-playing'); return; }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { track.classList.add('is-playing'); io.disconnect(); }
        });
      }, { threshold: 0.3 });
      io.observe(track);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["subopt-measurement"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var panels = document.querySelectorAll('[data-subopt-mrr]');
    if (!panels.length) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    panels.forEach(function (panel) {
      var counter = panel.querySelector('[data-subopt-count]');
      var tiles = Array.prototype.slice.call(panel.querySelectorAll('.subopt-measurement__tile'));
      var interval = null;

      function fmtCount(el, n) {
        el.textContent = (el.getAttribute('data-prefix') || '') + n + (el.getAttribute('data-suffix') || '');
      }

      function countUp(el) {
        var target = parseFloat(el.getAttribute('data-target')) || 0;
        var start = null, dur = 1500;
        function frame(t) {
          if (start === null) start = t;
          var p = Math.min((t - start) / dur, 1);
          var eased = 1 - Math.pow(1 - p, 3);
          fmtCount(el, Math.round(target * eased));
          if (p < 1) requestAnimationFrame(frame); else fmtCount(el, target);
        }
        requestAnimationFrame(frame);
      }

      var setCount = 3, idx = 0;
      function rotate() {
        idx = (idx + 1) % setCount;
        tiles.forEach(function (tile, i) {
          var vals = (tile.getAttribute('data-vals') || '').split('|');
          var keys = (tile.getAttribute('data-keys') || '').split('|');
          setTimeout(function () {
            tile.classList.add('is-out');
            setTimeout(function () {
              var v = tile.querySelector('.subopt-measurement__tile-val');
              var k = tile.querySelector('.subopt-measurement__tile-key');
              if (v) v.textContent = vals[idx] || vals[0] || '';
              if (k) k.textContent = keys[idx] || keys[0] || '';
              tile.classList.remove('is-out');
            }, 320);
          }, i * 90);
        });
      }

      function start() {
        panel.classList.add('is-playing');
        if (reduce) {
          if (counter) fmtCount(counter, parseFloat(counter.getAttribute('data-target')) || 0);
          return;
        }
        if (counter) setTimeout(function () { countUp(counter); }, 250);
        if (tiles.length) interval = setInterval(rotate, 4200);
      }

      if (!('IntersectionObserver' in window)) { start(); return; }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { start(); io.disconnect(); } });
      }, { threshold: 0.35 });
      io.observe(panel);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["subopt-offer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var boxes = document.querySelectorAll('[data-subopt-offer]');
    if (!boxes.length) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    boxes.forEach(function (box) {
      var one = box.querySelector('.ob-opt[data-opt="one"]');
      var sub = box.querySelector('.ob-opt[data-opt="sub"]');
      var detail = sub ? sub.querySelector('.ob-detail') : null;
      var pillWrap = box.querySelector('.ob-freq-pill');
      var pill = box.querySelector('[data-freq-value]');
      var cta = box.querySelector('.ob-cta');
      var ctaText = box.querySelector('[data-cta-text]');
      if (!one || !sub || !cta || !ctaText) return;

      var labelOne = box.getAttribute('data-cta-one') || '';
      var labelSub = box.getAttribute('data-cta-sub') || '';
      var freqs = (box.getAttribute('data-frequencies') || '').split(',')
        .map(function (s) { return s.trim(); }).filter(Boolean);

      var timers = [], started = false;
      function T(fn, ms) { timers.push(setTimeout(fn, ms)); }

      function reserve() {
        box.style.minHeight = '';
        var extra = sub.classList.contains('is-selected') || !detail ? 0 : detail.scrollHeight;
        box.style.minHeight = (box.offsetHeight + extra) + 'px';
      }
      reserve();
      var rT;
      window.addEventListener('resize', function () { clearTimeout(rT); rT = setTimeout(reserve, 150); });

      function selectSub(on) {
        sub.classList.toggle('is-selected', on);
        one.classList.toggle('is-selected', !on);
        cta.classList.toggle('is-sub', on);
        ctaText.textContent = on ? labelSub : labelOne;
      }

      function setFreq(v) {
        if (!pillWrap || !pill) return;
        pillWrap.classList.add('is-swapping');
        T(function () { pill.textContent = v; pillWrap.classList.remove('is-swapping'); }, 250);
      }

      function cycle() {
        selectSub(false);
        T(function () { selectSub(true); }, 1100);
        var base = 2800, step = 800, i;
        for (i = 1; i < freqs.length; i++) {
          (function (val, delay) { T(function () { setFreq(val); }, delay); })(freqs[i], base + (i - 1) * step);
        }
        var afterFreq = base + (freqs.length - 1) * step;
        if (freqs.length) T(function () { setFreq(freqs[0]); }, afterFreq);
        T(function () { cta.classList.add('is-pulsing'); }, afterFreq + 800);
        T(function () { cta.classList.remove('is-pulsing'); }, afterFreq + 1800);
        T(cycle, afterFreq + 4800);
      }

      function start() {
        if (started) return;
        started = true;
        if (reduce) { selectSub(true); return; }
        cycle();
      }

      if (!('IntersectionObserver' in window)) { start(); return; }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { start(); io.disconnect(); } });
      }, { threshold: 0.35 });
      io.observe(box);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["team-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var canvas = document.getElementById('team-hero-net');
    if (!canvas) return;
    var ctx = canvas.getContext('2d');

    // Colour and weight come from the section settings via data attributes.
    // NET() builds an rgba() at a given alpha so every element — links, node
    // fills, glows, the person marker — stays one colour and only the opacity
    // varies, which is what keeps the constellation reading as a single object.
    var NET_RGB = canvas.dataset.netRgb || '255, 255, 255';
    var LW = parseFloat(canvas.dataset.netLw) || 2.6;
    // Canvas shadows are a per-draw bloom, not a single backdrop: every node
    // paints its own, and two dozen overlapping glows haze the whole canvas —
    // which is what made the crisp links underneath read as soft. 0 is off.
    var GLOW = parseFloat(canvas.dataset.netGlow); if (isNaN(GLOW)) GLOW = 0;
    // Grows the constellation inside the same canvas box. Applied as a
    // transform so links, nodes and markers all scale together; the layout
    // maths below stays in unscaled coordinates.
    var S = (parseFloat(canvas.dataset.netScale) || 100) / 100;
    function NET(a) { return 'rgba(' + NET_RGB + ', ' + a + ')'; }
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var W = 0, H = 0, DPR = Math.min(window.devicePixelRatio || 1, 2);
    var nodes = [];

    function resize() {
      var r = canvas.getBoundingClientRect();
      if (!r.width) return;
      W = r.width; H = r.height;
      canvas.width = W * DPR; canvas.height = H * DPR;
      ctx.setTransform(DPR, 0, 0, DPR, 0, 0);
    }

    function seed() {
      nodes = [];
      var COLS = 6, ROWS = 4, i = 0;
      for (var c = 0; c < COLS; c++) {
        for (var rr = 0; rr < ROWS; rr++) {
          var jx = (Math.sin(i * 12.9898) * 43758.5453) % 1;
          var jy = (Math.sin(i * 78.233) * 12345.6789) % 1;
          var SMALL = H < 420;
          var PADX = SMALL ? 52 : 90, PADT = SMALL ? 86 : 120, PADB = SMALL ? 34 : 60;
          nodes.push({
            hx: PADX + ((c + 0.5 + (jx - 0.5) * 0.8) / COLS) * (W - PADX * 2),
            hy: PADT + ((rr + 0.5 + (jy - 0.5) * 0.8) / ROWS) * (H - PADT - PADB),
            amp: 6 + Math.abs(jx) * 10,
            sp: 0.25 + Math.abs(jy) * 0.35,
            ph: i * 1.7,
            r: (i % 4 === 0) ? 7 : 4,
            x: 0, y: 0
          });
          i++;
        }
      }
    }

    var popups = [], lastSpawn = 0;

    function drawPerson(x, y, sc, alpha) {
      var R = 30 * sc;
      ctx.globalAlpha = alpha;
      ctx.shadowColor = NET(0.85);
      ctx.shadowBlur = GLOW * 0.53;
      ctx.fillStyle = 'rgba(5, 14, 22, 0.95)';
      ctx.strokeStyle = NET(0.95);
      ctx.lineWidth = LW * 0.85;
      ctx.beginPath(); ctx.arc(x, y, R, 0, Math.PI * 2); ctx.fill(); ctx.stroke();
      ctx.shadowBlur = 0;
      ctx.strokeStyle = NET(alpha.toFixed(3));
      ctx.lineWidth = LW * 1.35 * sc;
      ctx.lineCap = 'round';
      ctx.beginPath(); ctx.arc(x, y - 8 * sc, 6.2 * sc, 0, Math.PI * 2); ctx.stroke();
      ctx.beginPath(); ctx.arc(x, y + 16 * sc, 11.5 * sc, Math.PI * 1.15, Math.PI * 1.85); ctx.stroke();
      ctx.globalAlpha = 1;
    }

    function draw(t) {
      // Clear unscaled, then draw scaled. The order matters: above 100% the
      // drawing extends past W/H, so clearing under the scaled transform would
      // leave a ring of the previous frame smeared around the edges.
      ctx.setTransform(DPR, 0, 0, DPR, 0, 0);
      ctx.clearRect(0, 0, W, H);
      ctx.setTransform(DPR * S, 0, 0, DPR * S, DPR * W * (1 - S) / 2, DPR * H * (1 - S) / 2);
      var BSC = H < 420 ? 0.85 : 1;
      var LINK = Math.max(170, Math.min(230, W * 0.42));
      var s = t / 1000;
      nodes.forEach(function (n) {
        n.x = n.hx + Math.sin(s * n.sp + n.ph) * n.amp;
        n.y = n.hy + Math.cos(s * n.sp * 0.8 + n.ph * 1.3) * n.amp;
      });
      for (var a = 0; a < nodes.length; a++) {
        for (var b = a + 1; b < nodes.length; b++) {
          var dx = nodes[a].x - nodes[b].x, dy = nodes[a].y - nodes[b].y;
          var dist = Math.sqrt(dx * dx + dy * dy);
          if (dist < LINK) {
            /* base was 1.1; white reads softer than the old saturated teal at the
               same alpha, so the links needed a touch more presence to carry. */
            var base = (1 - dist / LINK) * 1.25;
            var pulse = 0.65 + 0.35 * Math.sin(s * 1.4 + a * 0.9 + b * 0.4);
            ctx.strokeStyle = NET((base * pulse).toFixed(3));
            ctx.lineWidth = LW;
            ctx.beginPath();
            ctx.moveTo(nodes[a].x, nodes[a].y);
            ctx.lineTo(nodes[b].x, nodes[b].y);
            ctx.stroke();
          }
        }
      }
      nodes.forEach(function (n, i) {
        var tw = 0.75 + 0.25 * Math.sin(s * 1.8 + i);
        ctx.shadowColor = NET(0.95);
        // Keeps the old 34/24 relationship between large and small nodes.
        ctx.shadowBlur = n.r > 4 ? GLOW : GLOW * 0.7;
        ctx.fillStyle = n.r > 4 ? NET(tw.toFixed(3)) : NET((tw * 0.95).toFixed(3));
        ctx.beginPath();
        ctx.arc(n.x, n.y, n.r, 0, Math.PI * 2);
        ctx.fill();
      });
      ctx.shadowBlur = 0;
      if (t - lastSpawn > 1100 && popups.length < 5) {
        lastSpawn = t;
        var free = nodes.filter(function (n) { return !popups.some(function (p) { return p.node === n; }); });
        if (free.length) popups.push({ node: free[Math.floor(Math.random() * free.length)], born: t });
      }
      popups = popups.filter(function (p) { return t - p.born < 3000; });
      popups.forEach(function (p) {
        var age = (t - p.born) / 3000;
        var a = age < 0.15 ? age / 0.15 : (age > 0.8 ? (1 - age) / 0.2 : 1);
        var sc = age < 0.15 ? 0.6 + 0.4 * (age / 0.15) : 1;
        drawPerson(p.node.x, p.node.y - 40 * sc * BSC, sc * BSC, a);
      });
    }

    var running = false, raf = null;
    function loop(t) { draw(t); raf = requestAnimationFrame(loop); }
    function start() { if (!running) { running = true; raf = requestAnimationFrame(loop); } }
    function stop() { running = false; if (raf) cancelAnimationFrame(raf); }

    // Re-sync only when the box actually changed. resize() reallocates the
    // backing store and seed() re-randomises the node positions, so firing it
    // on every observer callback would visibly reshuffle the constellation
    // mid-transition.
    function syncSize() {
      var r = canvas.getBoundingClientRect();
      if (!r.width) return;
      if (Math.round(r.width) === Math.round(W) && Math.round(r.height) === Math.round(H)) return;
      resize(); seed();
      if (reduced) draw(4000);
    }

    resize(); seed();
    if (reduced) { draw(4000); }

    // A canvas backing store has to track the ELEMENT's box, not the window's.
    // On window resize alone it goes stale whenever the box changes for any
    // other reason — a webfont reflowing the hero, the background image
    // settling, a section above it expanding — and the browser then stretches
    // the old bitmap to fit, which reads as a soft, low-resolution canvas.
    if ('ResizeObserver' in window) {
      new ResizeObserver(syncSize).observe(canvas);
    }
    window.addEventListener('resize', syncSize);

    if (reduced) { return; }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { e.isIntersecting ? start() : stop(); });
      }, { threshold: 0.05 }).observe(canvas);
    } else {
      start();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["team-map"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('.team-map');
    var svg = document.getElementById('team-usmap');
    if (!root || !svg) return;
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var pins = [].slice.call(svg.querySelectorAll('.team-map__pin'));
    var timer = null;

    function rotate() {
      var idx = 0;
      function step() {
        pins.forEach(function (p) { p.classList.remove('is-active'); });
        var p = pins[idx % pins.length];
        p.classList.add('is-active');
        svg.appendChild(p);
        idx++;
      }
      step();
      timer = setInterval(step, 2600);
    }

    function start() {
      if (root.classList.contains('is-on')) return;
      root.classList.add('is-on');
      if (reduced) { pins.forEach(function (p, i) { if (i === 0) p.classList.add('is-active'); }); return; }
      setTimeout(rotate, pins.length * 120 + 500);
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { start(); io.disconnect(); } });
      }, { threshold: 0.2 });
      io.observe(root);
    } else {
      start();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["team-roster"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init() {
      var overlay = document.querySelector('[data-team-modal]');
      if (!overlay) return;
      // Lift the overlay to <body> so its fixed positioning sits above every
      // section stacking context (sibling sections with their own z-index or
      // isolation would otherwise trap it). Guard against re-running in the editor.
      if (overlay.parentNode !== document.body) document.body.appendChild(overlay);
      var modal = overlay.querySelector('.team-roster__modal');
      var closeBtn = overlay.querySelector('.team-roster__modal-close');
      var img = overlay.querySelector('.team-roster__modal-avatar img');
      var icon = overlay.querySelector('.team-roster__modal-avatar-icon');
      var nameEl = overlay.querySelector('.team-roster__modal-name');
      var roleEl = overlay.querySelector('.team-roster__modal-role');
      var bioEl = overlay.querySelector('.team-roster__modal-bio');
      var tagsEl = overlay.querySelector('.team-roster__modal-tags');
      var lastFocused = null;

      function open(card) {
        lastFocused = card;
        var name = card.getAttribute('data-name') || '';
        var role = card.getAttribute('data-role') || '';
        var bio = card.getAttribute('data-bio') || '';
        var tags = (card.getAttribute('data-tags') || '').split(',');
        var photo = card.getAttribute('data-photo') || '';

        nameEl.textContent = name;
        roleEl.textContent = role;
        roleEl.style.display = role ? '' : 'none';
        bioEl.textContent = bio;
        bioEl.style.display = bio ? '' : 'none';

        if (photo) {
          img.src = photo;
          img.alt = name;
          img.hidden = false;
          icon.style.display = 'none';
        } else {
          img.hidden = true;
          img.removeAttribute('src');
          icon.style.display = '';
        }

        tagsEl.innerHTML = '';
        tags.forEach(function (t) {
          var s = t.trim();
          if (!s) return;
          var span = document.createElement('span');
          span.className = 'team-roster__tag';
          span.textContent = s;
          tagsEl.appendChild(span);
        });

        overlay.classList.add('is-open');
        overlay.setAttribute('aria-hidden', 'false');
        document.body.classList.add('team-modal-open');
        if (closeBtn) closeBtn.focus();
      }

      function close() {
        overlay.classList.remove('is-open');
        overlay.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('team-modal-open');
        if (lastFocused && lastFocused.focus) lastFocused.focus();
      }

      document.addEventListener('click', function (e) {
        var card = e.target.closest('.team-roster__card');
        if (card) { open(card); return; }
        if (e.target === overlay || e.target.closest('.team-roster__modal-close')) close();
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && overlay.classList.contains('is-open')) { close(); return; }
        var card = e.target.closest && e.target.closest('.team-roster__card');
        if (card && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); open(card); }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ultra-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* Gate the orbit loops on scroll-in, matching the theme's other animated
       visuals: add .play once, then stop observing. */
    function playOrbits(scope) {
      var root = scope && scope.querySelectorAll ? scope : document;
      var wraps = root.querySelectorAll('.ultra-hero__orbit-wrap');

      Array.prototype.forEach.call(wraps, function (wrap) {
        if (wrap.dataset.orbitBound === '1') return;
        wrap.dataset.orbitBound = '1';

        var orbit = wrap.querySelector('.ultra-hero__orbit');

        function play() {
          wrap.classList.add('play');
          if (orbit) orbit.classList.add('play');
        }

        if (!('IntersectionObserver' in window)) {
          play();
          return;
        }

        var io = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                play();
                io.disconnect();
              }
            });
          },
          { threshold: 0.2 }
        );

        io.observe(wrap);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        playOrbits(document);
      });
    } else {
      playOrbits(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      playOrbits(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["what-section"] && !Shopify.designMode) return;
  try {
    
  /* Animated CRO wireframe. Everything is queried from the instance root via
     data-attributes rather than IDs, so a second copy of this section on a page
     animates independently instead of both driving the first one's nodes. */
  (function () {
    function build(root) {
      if (root.dataset.croBound === '1') return;
      root.dataset.croBound = '1';

      var q = function (sel) { return root.querySelector(sel); };
      var screenEl = q('[data-cro-screen]');
      if (!screenEl) return;

      var pdp = q('[data-cro-pdp]'), dash = q('[data-cro-dash]');
      var ring = q('[data-cro-ring]'), tip = q('[data-cro-tip]'), badge = q('[data-cro-badge]');
      var atc = q('[data-cro-atc]'), reviews = q('[data-cro-reviews]'), trust = q('[data-cro-trust]');
      var revKpi = q('[data-cro-rev]');
      var kpis = [].slice.call(dash.querySelectorAll('.cro-kpi-v'));
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var timers = [], running = false;

      kpis.forEach(function (el) { el.setAttribute('data-seed', el.textContent); });

      function rectIn(el) {
        var a = el.getBoundingClientRect(), b = screenEl.getBoundingClientRect();
        return { x: a.left - b.left, y: a.top - b.top, w: a.width, h: a.height };
      }

      /* Callouts are clamped inside the screen: the laptop can be scaled to any
         size by the customizer, so a tooltip positioned from fixed offsets would
         hang outside the bezel at small scales. */
      function place(el, box, r, above) {
        var w = el.offsetWidth, hh = el.offsetHeight, pad = 8;
        var x = Math.max(pad, Math.min(box.x, screenEl.clientWidth - w - pad));
        var y = above ? r.y - hh - 12 : r.y + r.h + 12;
        if (y < pad) y = r.y + r.h + 12;
        if (y + hh > screenEl.clientHeight - pad) y = Math.max(pad, r.y - hh - 12);
        y = Math.max(pad, Math.min(y, screenEl.clientHeight - hh - pad));
        el.style.left = x + 'px';
        el.style.top = y + 'px';
      }

      function ringTo(el, pad) {
        var r = rectIn(el); pad = pad == null ? 7 : pad;
        ring.style.left = (r.x - pad) + 'px';
        ring.style.top = (r.y - pad) + 'px';
        ring.style.width = (r.w + pad * 2) + 'px';
        ring.style.height = (r.h + pad * 2) + 'px';
      }

      function showTip(el, text, above) {
        tip.textContent = text;
        var r = rectIn(el);
        place(tip, { x: r.x - 6 }, r, above);
        tip.classList.add('on');
      }

      function showBadge(el, text, above) {
        badge.textContent = text;
        var r = rectIn(el);
        place(badge, { x: r.x + r.w - badge.offsetWidth }, r, above);
        badge.classList.add('on');
      }

      function hideCallouts() {
        ring.classList.remove('on');
        tip.classList.remove('on');
        badge.classList.remove('on');
      }

      function fmt(v, kind) {
        if (kind === 'int') return Math.round(v).toLocaleString('en-US');
        if (kind === 'pct') return v.toFixed(2) + '%';
        if (kind === 'usd') return '$' + Math.round(v).toLocaleString('en-US');
        return '$' + v.toFixed(2);
      }

      function countUp() {
        kpis.forEach(function (el) {
          var to = parseFloat(el.getAttribute('data-to')), kind = el.getAttribute('data-fmt');
          var from = parseFloat(String(el.getAttribute('data-seed')).replace(/[^0-9.]/g, '')) || 0;
          var t0 = null, dur = 1800;
          function step(ts) {
            if (!t0) t0 = ts;
            var p = Math.min((ts - t0) / dur, 1), e = 1 - Math.pow(1 - p, 3);
            el.textContent = fmt(from + (to - from) * e, kind);
            if (p < 1) requestAnimationFrame(step); else el.textContent = fmt(to, kind);
          }
          requestAnimationFrame(step);
        });
      }

      function reset() {
        timers.forEach(clearTimeout); timers = [];
        hideCallouts();
        atc.classList.remove('big');
        reviews.classList.remove('lift');
        trust.classList.remove('on');
        dash.classList.remove('run', 'on');
        revKpi.classList.remove('hot');
        kpis.forEach(function (el) { el.textContent = el.getAttribute('data-seed'); });
        pdp.classList.add('on');
      }

      function at(ms, fn) { timers.push(setTimeout(fn, ms)); }

      function run() {
        reset();
        at(1100,  function () { ringTo(atc, 8); ring.classList.add('on'); showTip(atc, 'Increase ATC button size', true); });
        at(2900,  function () { atc.classList.add('big'); ring.classList.remove('on'); tip.classList.remove('on'); });
        at(3350,  function () { ringTo(atc, 8); showBadge(atc, '+24% conversion rate', false); });
        at(5300,  function () { badge.classList.remove('on'); });
        at(5900,  function () { ringTo(reviews, 7); ring.classList.add('on'); showTip(reviews, 'Surface reviews above the fold', true); });
        at(7600,  function () { reviews.classList.add('lift'); ring.classList.remove('on'); tip.classList.remove('on'); });
        at(8050,  function () { showBadge(reviews, '+16% conversion rate', false); });
        at(10000, function () { badge.classList.remove('on'); });
        at(10600, function () { ringTo(trust, 7); ring.classList.add('on'); showTip(trust, 'Add trust badges at checkout', true); });
        at(12200, function () { trust.classList.add('on'); ring.classList.remove('on'); tip.classList.remove('on'); });
        at(12650, function () { showBadge(trust, '+9% conversion rate', false); });
        at(14600, hideCallouts);
        at(15300, function () { pdp.classList.remove('on'); dash.classList.add('on'); });
        at(15900, function () { dash.classList.add('run'); countUp(); });
        at(18000, function () { revKpi.classList.add('hot'); ringTo(revKpi, 6); ring.classList.add('on'); showBadge(revKpi, '+38% revenue', false); });
        at(20800, hideCallouts);
        at(21800, function () { if (running) run(); });
      }

      /* Reduced motion: skip straight to the end state so the story still reads
         as "changes applied, revenue up" without anything moving. */
      if (reduce) {
        pdp.classList.remove('on');
        dash.classList.add('on', 'run');
        revKpi.classList.add('hot');
        atc.classList.add('big');
        reviews.classList.add('lift');
        trust.classList.add('on');
        kpis.forEach(function (el) {
          el.textContent = fmt(parseFloat(el.getAttribute('data-to')), el.getAttribute('data-fmt'));
        });
        return;
      }

      if (!('IntersectionObserver' in window)) { running = true; run(); return; }

      /* Only animates while on screen — a 22s loop running off-screen is pure
         battery cost, and it also means the sequence starts from the top when
         the visitor actually reaches the section. */
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting && !running) { running = true; run(); }
          else if (!e.isIntersecting && running) { running = false; timers.forEach(clearTimeout); timers = []; }
        });
      }, { threshold: 0.25 }).observe(screenEl);
    }

    function init(scope) {
      (scope || document).querySelectorAll('[data-cro]').forEach(build);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(); });
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
